<template>
  <div class="documentDetails">
    <div v-if="loading || !document">
      <b-container fluid="xxl">
        <b-row class="justify-content-md-center">
            <b-col class="mt-5">
              <div class="spinner-border m-5" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </b-col>
        </b-row>
      </b-container>
    </div>
    <div v-else>
      <b-container fluid="xxl">
        <b-row>
          <b-col class="pl-0">
            <PageTitle v-if="document" v-bind:title="document.edition.sigleLegam" :pretitle="this.$t('DocLingTextDetails')" />
          </b-col>
          <b-col>
            <div class="mt-5 text-right">
              <!-- <button @click="downloadXML" class="btn-legam-xs mb-2" :disabled="checkXmlAvailable"> -->
              <button @click="downloadXML" class="btn-legam-xs mb-2">
                <b-icon icon="file-earmark-arrow-down-fill"></b-icon>{{ $t('DownloadXml') }}
              </button>
              <!-- <button @click="downloadPDF" class="btn-legam-xs mb-2" :disabled="checkPDFAvailable"> -->
              <button @click="downloadPDF" class="btn-legam-xs mb-2">
                <b-icon icon="file-binary-fill"></b-icon>{{ $t('DownloadPdf') }}
              </button>
              <span v-if="editMode && config.editable">
                <button @click="saveEdit" class="btn-legam-xs mb-2 btn-primary">
                  <b-icon icon="lock-fill"></b-icon>
                  Save changes
                </button>
                <button @click="cancelEdit" class="btn-legam-xs mb-2">
                  Cancel
                </button>
                <button v-if="$store.getters.checkRole('legam.doc.document.delete')" @click="deleteItem" class="btn-legam-xs mb-2 btn-danger">
                  <b-icon icon="trash2-fill"></b-icon>
                  Delete
                </button>
              </span>
              <span v-else>
                <button @click="unlockEdit" v-if="$store.getters.checkRole('legam.doc.document.modify')" class="btn-legam-xs mb-2">
                  <b-icon icon="unlock-fill"></b-icon>
                  Unlock editing
                </button>
                <button v-if="!$store.getters.checkRole('legam.doc.document.modify') && $store.getters.checkRole('legam.doc.document.delete')" @click="deleteItem" class="btn-legam-xs mb-2 btn-danger">
                  <b-icon icon="trash2-fill"></b-icon>
                  Delete
                </button>
              </span>
            </div>
          </b-col>
        </b-row>
        <b-row class="justify-content-md-center">
          <b-col>
            <article>
              <b-row>
                <b-col style="position: relative">
                  <b-row>
                    <b-col cols="12">
                      <b-row>
                        <b-col cols="4">
                          <div class="legam-details-box">
                            <b-row>
                              <b-col>
                                <h6>{{ $t('SigleEdition') }}</h6>
                                <EditionSelect v-if="editMode" :edition="document.edition" @select="selectEdition" />
                                <span v-else>
                                  <router-link
                                    v-if="document.edition"
                                    :to="{name: 'EditionDetails', params: {
                                      slug: document.edition.sigleLegamNormalized,
                                      id: document.edition.id
                                    }}"
                                    v-html="document.edition.sigleLegam"
                                  ></router-link>
                                  <font style="color:gray">  [{{ document.edition.liability }}]</font>
                                </span>
                              </b-col>
                            </b-row>
                            <b-row class="mt-3">
                              <b-col>
                                <h6>{{ $t('Corpus') }}<span v-if="editMode"> (change on edition)</span></h6>
                                <span v-if="document.corpus && document.corpus.edition">
                                  <router-link
                                    v-if="document.corpus.edition"
                                    :to="{name: 'EditionDetails', params: {
                                      slug: document.corpus.edition.sigleLegamNormalized,
                                      id: document.corpus.edition.id
                                    }}"
                                    v-html="document.corpus.edition.sigleLegam"
                                  ></router-link>
                                </span>
                              </b-col>
                            </b-row>
                            <b-row class="mt-3">
                              <b-col>
                                <h6>{{ $t('Transcription') }}<span v-if="editMode"> (change on edition)</span></h6>
                                <span v-if="document.edition.transcription" v-html="document.edition.transcription" />
                                <span v-else v-html="document.corpus.edition.transcription" />
                              </b-col>
                            </b-row>
                            <b-row class="mt-3">
                              <b-col>
                                <h6>{{ $t('Responsibility') }}<span v-if="editMode"> (change on edition)</span></h6>
                                <span v-if="document.edition.responsibility" v-html="document.edition.responsibility" />
                                <span v-else v-html="document.corpus.edition.responsibility" />
                              </b-col>
                            </b-row>
                          </div>
                          <div class="legam-details-box mt-3">
                            <b-row>
                              <b-col>
                                <h6>{{ $t('Date') }}<span v-if="editMode"> (change on manuscript)</span></h6>
                                <span v-if="document.manuscript" v-html="document.manuscript.commentDate" />
                              </b-col>
                            </b-row>
                            <b-row class="mt-3">
                              <b-col>
                                <h6>{{ $t('DateNum') }}<span v-if="editMode"> (change on manuscript)</span></h6>
                                <span v-if="document.manuscript" v-html="document.manuscript.dateNum" />
                              </b-col>
                            </b-row>
                            <b-row class="mt-3">
                              <b-col>
                                <h6>{{ $t('Scripta') }}<span v-if="editMode"> (change on manuscript)</span></h6>
                                <span v-if="document.manuscript && document.manuscript.localization" v-html="document.manuscript.localization.scriptas.map(scripta => scripta.code).join(', ')" />
                              </b-col>
                            </b-row>
                            <b-row class="mt-3">
                              <b-col>
                                <h6>{{ $t('Location') }}<span v-if="editMode"> (change on manuscript)</span></h6>
                                <span v-if="document.manuscript && document.manuscript.localization" v-html="document.manuscript.localization.locations.map(location => location.display).join(', ')" />
                              </b-col>
                            </b-row>
                            <b-row class="mt-3">
                              <b-col>
                                <h6>{{ $t('Genre') }}<span v-if="editMode"> (change on text)</span></h6>
                                <span v-if="document.edition" v-html="document.genre" />
                              </b-col>
                            </b-row>
                          </div>
                        </b-col>
                        <b-col cols="4">
                          <b-row class="mt-4-8">
                            <b-col>&nbsp;</b-col>
                          </b-row>
                          <div class="legam-details-box mt-3">
                            <b-row>
                              <b-col>
                                <h6>{{ $t('Authorized') }}</h6>
                                <b-form-input
                                  id="authorized"
                                  v-model="document.authorized"
                                  placeholder="Authorized"
                                  v-if="editMode"
                                ></b-form-input>
                                <span v-else v-html="document.authorized"></span>
                              </b-col>
                            </b-row>
                            <b-row class="mt-3">
                              <b-col>
                                <h6>{{ $t('Arranger') }}</h6>
                                <b-form-input
                                  id="arranger"
                                  v-model="document.arranger"
                                  placeholder="Arranger"
                                  v-if="editMode"
                                ></b-form-input>
                                <span v-else v-html="document.arranger"></span>
                              </b-col>
                            </b-row>
                            <b-row class="mt-3">
                              <b-col>
                                <h6>{{ $t('SealProvider') }}</h6>
                                <b-form-input
                                  id="sealProvider"
                                  v-model="document.sealProvider"
                                  placeholder="Arranger"
                                  v-if="editMode"
                                ></b-form-input>
                                <span v-else v-html="document.sealProvider"></span>
                              </b-col>
                            </b-row>
                            <b-row class="mt-3">
                              <b-col>
                                <h6>{{ $t('Beneficiary') }}</h6>
                                <b-form-input
                                  id="beneficiary"
                                  v-model="document.beneficiary"
                                  placeholder="Beneficiary"
                                  v-if="editMode"
                                ></b-form-input>
                                <span v-else v-html="document.beneficiary"></span>
                              </b-col>
                            </b-row>
                            <b-row class="mt-3">
                              <b-col>
                                <h6>{{ $t('Agent') }}</h6>
                                <b-form-input
                                  id="agent"
                                  v-model="document.agent"
                                  placeholder="Agent"
                                  v-if="editMode"
                                ></b-form-input>
                                <span v-else v-html="document.agent"></span>
                              </b-col>
                            </b-row>
                            <b-row class="mt-3">
                              <b-col>
                                <h6>{{ $t('PlaceOfIssue') }}<span v-if="editMode"> (change on text)</span></h6>
                                <span v-if="document.text" v-html="document.text.placeOfIssue" />
                              </b-col>
                            </b-row>
                            <b-row class="mt-3">
                              <b-col>
                                <h6>{{ $t('Scriptoria') }}<span v-if="editMode"> (change on manuscript > localization > scriptorium)</span></h6>
                                <div
                                  v-if="document.manuscript && document.manuscript.localization && document.manuscript.localization.scriptoriums"
                                >
                                  <ul style="list-style-type:none;list-style-position: outside;">
                                    <li
                                      v-for="scr in document.manuscript.localization.scriptoriums"
                                      :key="scr.id"
                                      style="margin-left: -40px;"
                                    >
                                      <router-link
                                        :to="{name: 'ScriptoriumDetails', params: {
                                          id: scr.id
                                        }}"
                                        v-html="scriptoriumString(scr)"
                                      ></router-link>
                                    </li>
                                  </ul>
                                </div>
                              </b-col>
                            </b-row>
                            <b-row class="mt-3">
                              <b-col>
                                <h6>{{ $t('CommentScriptorium') }}<span v-if="editMode"> (change on manuscript > localization)</span></h6>
                                <span
                                  v-if="document.manuscript && document.manuscript.localization"
                                  v-html="document.manuscript.localization.commentScriptorium"
                                />
                              </b-col>
                            </b-row>
                            <b-row class="mt-3">
                              <b-col>
                                <h6>{{ $t('Scribe') }}<span v-if="editMode"> (change on manuscript > personhist > scribe)</span></h6>
                                <span
                                  v-if="document.manuscript && document.manuscript.personhists"
                                  v-html="document.manuscript.personhists.filter(personhist => personhist.relationType == 'scribe').map(personhist => personhist.fullName).join(', ')"
                                />
                              </b-col>
                            </b-row>
                          </div>
                        </b-col>
                        <b-col cols="4">
                          <b-row>
                            <b-col>
                              <h6>{{ $t('Text') }}</h6>
                              <TextSelect v-if="editMode" :text="document.text" @select="selectText" />
                              <span v-else>
                                <router-link
                                  v-if="document.text"
                                  :to="{name: 'TextDetails', params: {
                                    slug: document.text.sigleLegamNormalized,
                                    id: document.text.id
                                  }}"
                                  v-html="document.text.sigleLegam"
                                ></router-link>
                              </span>
                            </b-col>
                          </b-row>
                          <div class="legam-details-box mt-3">
                            <b-row>
                              <b-col>
                                <h6>{{ $t('ManuscriptCode') }}</h6>
                                <ManuscriptSelect v-if="editMode" :manuscript="document.manuscript" @select="selectManuscript" />
                                <span v-else>
                                  <router-link
                                    v-if="document.manuscript"
                                    :to="{name: 'ManuscriptDetails', params: {
                                      slug: document.manuscript.codeRepcritNormalized,
                                      id: document.manuscript.id
                                    }}"
                                    v-html="document.manuscript.codeRepcrit"
                                  ></router-link>
                                  <font v-if="document.manuscript.transmissionMode" style="color:gray">  [{{ document.manuscript.transmissionMode }}]</font>
                                </span>
                              </b-col>
                            </b-row>
                            <b-row class="mt-3">
                              <b-col>
                                <h6>{{ $t('FullCode') }}<span v-if="editMode"> (change on manuscript)</span></h6>
                                <span
                                  v-if="document.manuscript"
                                  v-html="document.manuscript.codeFull"
                                />
                              </b-col>
                            </b-row>
                            <b-row class="mt-3">
                              <b-col>
                                <h6>{{ $t('Materials') }}<span v-if="editMode"> (change on manuscript)</span></h6>
                                <span
                                  v-if="document.manuscript"
                                  v-html="document.manuscript.materials"
                                />
                              </b-col>
                            </b-row>
                            <b-row class="mt-3">
                              <b-col>
                                <h6>{{ $t('FormerEdition') }}<span v-if="editMode"> (change on edition)</span></h6>
                                <span
                                  v-if="document.edition"
                                  v-html="document.edition.formerEdition"
                                />
                              </b-col>
                            </b-row>
                            <b-row class="mt-3">
                              <b-col>
                                <h6>{{ $t('FormerDescription') }}<span v-if="editMode"> (change on edition)</span></h6>
                                <span
                                  v-if="document.edition"
                                  v-html="document.edition.formerDescription"
                                />
                              </b-col>
                            </b-row>
                            <b-row class="mt-3">
                              <b-col>
                                <h6>{{ $t('CommentWriting') }}<span v-if="editMode"> (change on manuscript)</span></h6>
                                <span
                                  v-if="document.manuscript"
                                  v-html="document.manuscript.commentWriting"
                                />
                              </b-col>
                            </b-row>
                            <b-row class="mt-3">
                              <b-col>
                                <h6>{{ $t('CommentGeneral') }}<span v-if="editMode"> (change on manuscript)</span></h6>
                                <span
                                  v-if="document.manuscript"
                                  v-html="document.manuscript.commentGeneral"
                                />
                              </b-col>
                            </b-row>
                          </div>
                          <b-row class="mt-3">
                            <b-col>
                              <h6>{{ $t('Verso') }}</h6>
                              <b-form-input
                                id="sealProvider"
                                v-model="document.verso"
                                placeholder="Verso"
                                v-if="editMode"
                              ></b-form-input>
                              <span v-else v-html="document.verso"></span>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                      <b-row class="mt-3">
                        <b-col cols="8">
                          <h6>{{ $t('Regest') }}</h6>
                          <b-form-textarea
                            id="regest"
                            placeholder="Regest"
                            v-model="document.regest"
                            rows="3"
                            max-rows="6"
                            v-if="editMode"
                          ></b-form-textarea>
                          <span v-else v-html="document.regest"></span>
                        </b-col>
                      </b-row>
                    </b-col>

                    <b-col cols="8" class="mt-4">
                      <h6>{{ $t('Content') }}</h6>
                      <b-form-group label="Edit" class="small-title" v-if="editMode">
                        <b-form-radio-group
                          v-model="editViewType"
                          :options="editViewTypes"
                          name="edit-view-type-btn"
                          size="sm"
                          buttons
                        ></b-form-radio-group>
                      </b-form-group>
                      <b-form-group :label="$t('EditionViewBy')" class="small-title" v-else>
                        <b-form-radio-group
                          v-model="viewType"
                          :options="viewTypes"
                          name="view-type-btn"
                          size="sm"
                          buttons
                        ></b-form-radio-group>
                      </b-form-group>

                      <label class="switch" label="test">
                        <input type="checkbox" v-model="showHyperlinks">
                      {{ $t('ShowHyperlinks') }}
                      </label>

                      <div class="content-box" @click="openContextMenu" :class="showHyperlinks ? 'show-hyperlinks' : ''">
                        <span v-html="computedContent" class="contentRoot edit-parent" :class="viewType + ' ' + (editMode ? 'edit-' + editViewType : '')"></span>
                        <span v-if="footnotesFue.length" class="footnotes">
                          <small><b>{{ $t('TranscriptionNotes') }}</b></small><br>
                          <p
                            v-for="(footnote, index) in footnotesFue"
                            :key="'fue-' + index"
                            class="tooltip-box"
                            @mouseover="highlightId = footnote.id"
                            @mouseleave="highlightId = null"
                          >
                            <sup>{{ letterNumeration(index+1) }}</sup> <span v-html="footnote.content"></span>
                            <span class="contextmenu" v-if="editMode">
                              <button class="btn-legam-tooltip" @click="editFootnote(footnote)">
                                <b-icon icon="pencil"></b-icon>
                                Edit
                              </button>
                              <button class="btn-legam-tooltip" @click="deleteFootnote(footnote)">
                                <b-icon icon="trash"></b-icon>
                                Delete
                              </button>
                            </span>
                          </p>
                        </span>
                        <span v-if="footnotesFul.length" class="footnotes">
                          <small><b>{{ $t('LinguisticNotes') }}</b></small><br>
                          <p
                            v-for="(footnote, index) in footnotesFul"
                            :key="'ful-' + index"
                            class="tooltip-box"
                            @mouseover="highlightId = footnote.id"
                            @mouseleave="highlightId = null"
                          >
                            <sup>{{index+1}}</sup> <span v-html="footnote.content"></span>
                            <span class="contextmenu" v-if="editMode">
                              <button class="btn-legam-tooltip" @click="editFootnote(footnote)">
                                <b-icon icon="pencil"></b-icon>
                                Edit
                              </button>
                              <button class="btn-legam-tooltip" @click="deleteFootnote(footnote)">
                                <b-icon icon="trash"></b-icon>
                                Delete
                              </button>
                            </span>
                          </p>
                        </span>
                        <div
                          class="contextMenu"
                          v-if="showContextMenu"
                          @mouseleave="mouseLeave"
                          :style="'top:' + CMtop + 'px; left: ' + CMleft + 'px'"
                        >
                          <span v-if="(editMode == false && (viewType == 'critic' || viewType == 'interpretative')) || (editMode == true && editViewType == 'div')">
                            <button class="btn-legam-tooltip" @click="filterDivision" v-if="config.editable">
                              Filter by division
                            </button>
                            <router-link
                              class="btn-legam-tooltip"
                              v-for="(tokenData, i) in contextMenuLemmas"
                              :key="`tokenContext-${i}`"
                              :to="{name: 'Lemma', params: { id: tokenData[0]}}"
                              target='_blank'
                              v-html="'Open Lemma «' + tokenData[1] + '»'"
                            ></router-link>
                            <br>
                          </span>
                          <span v-if="editMode">
                            <span v-if="editViewType == 'div'">
                              <button class="btn-legam-tooltip" @click="addFootnote">
                                Add footnote
                              </button>
                              <br>
                            </span>
                            <span v-if="editViewType == 'par'">
                              <button class="btn-legam-tooltip" @click="mergeElements" v-if="canElementBeMerged">
                                Merge paragraphs (with next one)
                              </button>
                              <span class="btn-legam-tooltip disabled" v-else>
                                Paragraphs can't be merged
                              </span>
                              <br>
                              <button class="btn-legam-tooltip" @click="splitElement">
                                Split paragraph
                              </button>
                            </span>
                            <span v-else-if="editViewType == 'zw'">
                              <button class="btn-legam-tooltip" @click="mergeElements" v-if="canElementBeMerged">
                                Merge lines (with next one)
                              </button>
                              <span class="btn-legam-tooltip disabled" v-else>
                                Lines can't be merged
                              </span>
                              <br>
                              <button class="btn-legam-tooltip" @click="splitElement">
                                Split line
                              </button>
                            </span>
                            <span v-else>
                              <button class="btn-legam-tooltip" @click="mergeElements" v-if="canElementBeMerged">
                                Merge divisons (with next one)
                              </button>
                              <span class="btn-legam-tooltip disabled" v-else>
                                Divisions can't be merged
                              </span>
                              <br>
                              <button class="btn-legam-tooltip" @click="splitElement">
                                Split division
                              </button>
                            </span>
                          </span>
                        </div>
                      </div>
                    </b-col>
                    <b-col cols="4" class="img-col">
                      <img v-img:group v-for="medium in document.media"
                        :key="medium.id"
                        :src="`${imagePath}/${medium.file_path}`"
                        class="t-nail" />
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </article>
          </b-col>
        </b-row>

        <div class="accordion mt-4" role="tablist" v-if="config.editable">
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-1 class="text-left">
                Tokens
                <!-- Tokens <small>({{ document.tokens.length }} {{ document.tokens.length === 1 ? 'entry' : "entries" }})</small> -->
                <span class="when-open float-right">-</span>
                <span class="when-closed float-right">+</span>
              </b-button>
            </b-card-header>
            <b-collapse id="accordion-1" visible accordion="my-accordion-1" role="tabpanel">
              <b-card-body>
                <!-- <LegamDataTables v-bind="$data.tokensDataTables" /> -->
                <!-- <span v-if="editMode" class="btn-legam-xs btn-legam-xxs ml-2 mb-2 float-right" v-b-modal.modal-add-token>
                  <b-icon icon="plus"></b-icon>
                  Add
                </span>
                <b-modal id="modal-add-token" title="Add token" ok-only ok-variant="secondary" size="lg">
                  <TokenAutocomplete @select="addStudy" />
                </b-modal> -->
                <TokenTable
                  v-if="documentTokens && config.editable"
                  :key="indexKeyTokenTable"
                  :tokens="documentTokens"
                  :editMode="editMode"
                  @highlight="highlightToken"
                  @refresh="reloadData"
                  :divisionFilter="divisionFilter"
                />
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
      </b-container>
    </div>

    <b-modal
      id="modal-add-footnote"
      title="Add footnote"
      ok-variant="secondary"
      size="xl"
      @ok="saveFootnote"
      @hidden="footnoteData = null"
      ok-title="Save"
    >
      <div class="text-center split-text" v-if="footnoteData">
        <span
          v-for="(letter, index) in footnoteData.content.content.split('')"
          :key="'footnote-index-' + index"
          @click="footnoteSetIndex(index)"
        >{{ letter }}<span
          class="legam-split-divider"
          v-if="footnoteData.allowedIndices.legal_indices_shifted[footnoteIndex] == index"
        >|</span><span
          class="legam-split-divider-spaceholder"
          v-else-if="footnoteData.allowedIndices.legal_indices_shifted.includes(index)"
        >|</span></span>
      </div>
      <b-form-textarea
        id="textarea"
        class="no-arrows"
        v-model="footnoteText"
        placeholder="Footnote text"
        rows="3"
        max-rows="6"
      ></b-form-textarea>
      <div class="mt-2">
        <b-form-radio-group v-model="footnoteType">
          <b-form-radio value="ful">Linguistic Note</b-form-radio>
          <b-form-radio value="fue">Transcription Note</b-form-radio>
        </b-form-radio-group>
      </div>
    </b-modal>

    <b-modal
      id="modal-split-element"
      title="Split element"
      ok-variant="secondary"
      size="xl"
      @ok="saveSplitElement"
      @hidden="splitElementData = null"
      ok-title="Save"
    >
      <div class="text-center split-text" v-if="splitElementData">
        <span
          v-for="(letter, index) in splitElementData.content.content.split('')"
          :key="'split-index-' + index"
          @click="splitElementSetIndex(index)"
        ><span
          class="legam-split-divider"
          v-if="splitElementData.allowedIndices.legal_indices_shifted[splitElementIndex] == index"
        >|</span><span
          class="legam-split-divider-spaceholder"
          v-else-if="splitElementData.allowedIndices.legal_indices_shifted.includes(index)"
        >|</span>{{ letter }}</span>
      </div>
    </b-modal>

    <b-modal
      id="modal-edit-footnote"
      title="Edit footnote"
      ok-variant="secondary"
      size="xl"
      @ok="saveEditFootnote"
      ok-title="Save"
    >
      <b-form-textarea
        id="textarea"
        v-model="footnoteText"
        placeholder="Footnote text"
        rows="3"
        max-rows="6"
      ></b-form-textarea>
    </b-modal>

    <component :is="`style`">
      sup[data-id="{{ highlightId }}"] {
        background-color: rgba(255, 0, 0, 0.7);
        color: #fff;
      }
    </component>
  </div>
</template>

<style scoped>
  * >>> .tdAction {
    width: 70px;
  }

  * >>> .tdEdition {
    width: 70%;
  }

  * >>> .tdDateNum {
    width: 20%;
  }

  * >>> .show-hyperlinks .hl1 {
    /* background-color: greenyellow; */
    background-color: #1e9988;
    color: #fff;
  }

  * >>> .show-hyperlinks .hl2 {
    /* background-color: greenyellow; */
    background-color: #e7f5ff;
  }

  * >>> .content-box {
    font-size: 18px;
  }

  * >>> .content-box maj {
    font-weight: bold;
  }

  * >>> .content-box abr {
    font-style: italic;
  }

  .content-box p {
    margin-bottom: 2px;
  }

  * >>> .content-box .legam-zw {
    font-size: 13px;
    opacity: 0.6;
  }
  * >>> .content-box .footnotes {
    display: block;
    margin-top: 13px;
  }

  * >>> .content-box .footnotes:before {
    content: "";
    display: block;
    width: 20%;
    padding-top: 10px;
    border-bottom: 1px solid rgb(162, 162, 162);
  }

  * >>> .content-box .edit-parent span.legam-zw,
  * >>> .content-box .edit-parent span.legam-div {
    min-width: 15px;
    padding-right: 5px;
    display: inline-block;
  }

  * >>> .content-box .edit-parent:not(.diplomatic):not(.edit-zw) span.legam-zw.inside {
    width: auto;
  }

  * >>> .content-box .interpretative punct[original],
  * >>> .content-box .diplomatic punct {
    display: none;
  }

  * >>> .content-box .diplomatic punct[original] {
    display: inline;
  }

  * >>> .content-box {
    counter-reset: line-number;
  }
  * >>> .content-box div.division {
    counter-increment: line-number;
    /* padding: 1px 2px 1px 2px; */
    background-color: #f3f3f3;
    margin-bottom: 4px;
    border-radius: 3px;
    display: inline;
    margin-right: 7px;
    /* line-height: 23px; */
  }
  .public-ui * >>> .content-box div.division {
    background-color: transparent;
  }
  * >>> .content-box .edit-div div {
    display: block;
    margin-bottom: 4px;
    background-color: #fff;
  }
  * >>> .content-box .edit-parent div.legam-line {
    margin-bottom: 4px;
  }
  * >>> .content-box div.division:hover,
  * >>> .content-box div.legam-par:hover,
  * >>> .content-box div.legam-line:hover {
    cursor: pointer;
    background-color: #e4e4e4;
  }
  * >>> .show-hyperlinks .content-box div:hover span.hl2 {
    background-color: #d5ebfb;
  }
  * >>> .content-box div > span.legam-div {
    vertical-align: super;
    font-size: 10px;
    font-weight: bold;
  }
  * >>> .content-box .edit-div div > span.legam-div {
    font-weight: normal;
    font-size: 10px;
    vertical-align: baseline;
    opacity: 0.6;
  }
  .contextMenu {
    background-color: #5a6268ed !important;
    position: fixed;
    padding: 10px 10px;
    z-index: 10000;
  }
  .legam-split-divider,
  .legam-split-divider-spaceholder {
    padding: 0px 3px;
    color: red;
    font-size: 30px;
  }
  .legam-split-divider-spaceholder {
    color: #dfdfdf;
  }
  .split-text {
    text-align: center;
    margin-bottom: 10px;
    font-size: 25px;
  }
  .text-center {
    text-align: center;
  }
  .text-center span {
    cursor: s-resize;
  }
  .disabled {
    opacity: 0.5;
  }
  .t-nail {
    height: 200px;
  }
  .img-col {
    margin-top: 2cm;
  }
</style>

<script>
  import { mapState } from 'vuex'
  import PageTitle from '@/components/PageTitle.vue'
  import router from '@/router'
  import Utils from '@/utils.js'
  import EditionSelect from '@/components/Bibliography/EditionSelect.vue'
  import ManuscriptSelect from '@/components/Bibliography/ManuscriptSelect.vue'
  import TextSelect from '@/components/Bibliography/TextSelect.vue'
  import CorpusSelect from '@/components/Document/CorpusSelect.vue'
  import TokenTable from '@/components/Document/TokenTable.vue'
  import config from '@/config.js'
  import Vue from 'vue';
  import vImg from 'v-img';
  Vue.use(vImg);

  export default {
    name: 'DocumentDetails',
    data() {
      return {
        config: config,
        documentId: this.$route.params.id,
        editMode: false,
        loading: true,
        showDetails: false,
        documentTokens: null,
        indexKeyTokenTable: 0,
        elementNum: null,
        divisionFilter: null,
        showContextMenu: false,
        contextMenuLemmas: [],
        showHyperlinks: false,
        tokenLemmas: {},
        CMtop: 0,
        CMleft: 0,

        highlightId: null,

        footnoteData: null,
        // footnoteModalContent: null,
        footnoteIndex: 0,
        // footnoteOffset: 0,
        footnoteText: '',
        footnoteType: 'ful',
        footnoteId: null,
        footnotesFue: [],
        footnotesFul: [],
        footnoteAllowedIndicies: [],
        canElementBeMerged: false,

        splitElementIndex: 0,
        splitElementData: null,
        computedContent: '',

        contentChanges: [],

        viewType: 'critic',
        viewTypes: [
          { text: 'Critic', value: this.$t('critic') },
          { text: 'Interpretative', value: this.$t('interpretative') },
          { text: 'Diplomatic', value: this.$t('diplomatic') },
        ],
        editViewType: 'div',
        editViewTypes: [
          { text: 'Division', value: 'div' },
          { text: 'Paragraph', value: 'par' },
          { text: 'Line', value: 'zw' },
        ],
        imagePath: config.imagesUrl,
        selectedImage: null,

        checkbox: true,

        availablePDFs: ["00031b8c-6f9d-4416-956f-ee89d16e2577","0c4d5336-592b-437b-9eee-a63cf01fffc1","1a34ace5-fac7-4c22-abb6-c31bcfd3fbb5","27840e37-f58c-4a40-82a5-b2ac58bf4ec1","35de233c-3424-4f59-8beb-9c742a8e62f5","000a4c37-ec65-4722-89d9-4b49f8d65fb8","0c6ac58a-7e7d-4d54-81cb-1daad30a3e44","1a40abc7-bf93-497a-8919-dd2de7672558","278e06b4-274a-4bd5-bf9e-33695491eb28","35ef5aaf-9684-4963-a162-33d0661b96de","00149c3b-df7c-4a92-9149-c7946f43db2c","0c78fa74-fe3b-4b57-88ee-4aa1f667660d","1a41310b-93f3-4d88-8b4f-4358a90ed155","279c6d3b-fd0b-4c84-8bf3-ccf5e59c9804","35f0ac71-cfc4-469f-b6cb-69ad9cfc5a13","002ed1c7-8e40-4763-a4b0-de519a1b5f84","0c7b8b9b-005d-4f21-b834-e73e031f5930","1a4c6115-00e4-49d4-bfef-08ac174a52f7","27a40820-4c7d-4491-9a26-67c68c733362","35f8f86d-596a-46bf-b745-708d18e522a8","00395274-8734-48fe-b123-3bb20f0e662d","0c7db9c3-81a5-46d3-90a0-ccb6844ebb55","1a5058cd-67fc-489f-8410-2d4b2c079d70","27ac9150-7c87-4906-ada9-49710d721f3d","35fa6dd2-9af1-4d31-94cd-da5f42fdb906","0061f489-f6cb-4caa-9858-a91bc4e4dd40","0c7f5d1f-589e-4539-a361-f05a2b28934a","1a521d61-fddb-40f0-a668-71abd4004d7c","27b39f25-e7c8-451e-bbee-18c2ad8a5639","3603c836-b896-4a5e-b0fe-cd3bc21a87df","00725a60-7247-4236-9be6-7fe734f635e0","0c8e7994-af30-4784-bfab-4d7a9975aedc","1a54008f-e4f4-4f2e-bdf3-2b2d736e5775","27e6cea8-65e2-4971-b8ef-fb64b6d69da6","36048bc1-c282-4855-9644-21c1abdd1689","00730c95-6312-4a1c-bf7c-8364b22135cd","0c9181c0-586b-411c-8c63-7746c5e9fa41","1a68196b-f5c0-415f-8dfe-390da86d0ff9","27eb2d64-5287-4da5-a7c9-49b772d4df63","360cd3cc-2177-4ce7-8f8a-d90cc0e1626a","007b0625-6454-4f48-b158-c59996aa32ea","0c97ac90-f07c-4854-bd4e-cdd9af63454e","1a710ad4-e293-4c0c-80ff-5fa25826d959","27ef7e49-142c-4366-8b87-e59c2f986f10","361ba289-1c3d-4e91-8645-cdde941ec9f6","008bf243-a979-409a-8d62-da53dc210c65","0caae379-ab6e-4703-a116-5a671558da37","1a85c323-2359-49c7-8a45-daedd3c459a4","27fba348-a873-4b11-94e6-98084d39044b","361ff17a-079d-4058-860b-9f6ce741b9f7","009178fb-5cc3-46fa-a10a-62b29d1a7095","0cb2c708-b20d-4dfc-aeca-79e7bd4722d2","1a8c5243-a8d1-4a8d-83ef-1a868b67f184","280093da-8eb6-48b1-a395-7b1b8c5c0490","36368d09-b059-4a34-b393-02f6838cf1b2","0096c8b3-e92a-4266-9a79-8cd310eb2f6a","0cb6f066-f636-463a-aa5b-900c3315c3d9","1a9bae1d-de3c-460e-b3d2-6638f9a72ef5","28208164-8a49-4b1d-88b0-ed9982abccc7","36423736-2a8b-474f-935f-84801853daf7","009889b8-cd09-47ad-ba17-e06ccd30a0c9","0cbacc64-e49f-4222-911f-899816d270d2","1aa3e36b-dff9-46cc-b42d-9d2348cb58d9","28252628-d548-40d1-9d49-c9df3d6175ca","36426677-b812-436e-a96d-6ff094d2d74a","009f7d65-04c6-4274-a3fe-e002fc9b857e","0cbd4edd-5423-4c9e-91db-fd60145cab54","1ab4a415-edb7-4155-b759-ea66e8fe52a1","282b3474-2861-4f5c-b175-2b154a5c01a4","3646b8cf-5d6c-476c-9fe7-edb37a1e17a9","00a6e6e2-8304-4555-ae64-7cd711de45a6","0cbf11c9-eab0-4b22-852f-1e261b5eed4b","1ab7ac0d-b717-46a5-b631-1c43fc3dfb74","2844d0e2-2219-4a96-95f7-78498fc41735","364dd0b2-35a7-4495-9122-77dac64b03da","00a792c8-93e6-4688-902f-201948ef2b32","0cc06062-3dab-4225-abeb-e83fa8934462","1ab90739-f5df-4f24-97b8-76b4b1dc96db","2846dcb3-b894-4fb2-bcb8-2407c5f26777","3652380a-e3db-4390-8a07-4ab3e492ffc3","00ad8532-1700-4e33-a25b-194b67985371","0cc65eaf-c265-432a-be33-03c0338d455e","1abe93fa-0a7e-4bf9-a93e-f82c8f63a233","285bd5ed-a14d-41ce-bbcf-16475a8ffd65","36555ac2-0493-44ed-a606-fd9f9479c958","00b5a887-d674-4b99-bd89-a2e351dea586","0ce60d0d-5d7c-48ec-b0c3-e77627d42652","1ac19cc9-445f-47ed-b8cd-0cd3360d20ac","2875d11d-b06e-46ba-97dd-0482792f99bf","365776d6-d6dd-43d0-a1dc-7e253f48b277","00c4dbb8-5683-4672-9998-3aef3a158940","0ce936c9-e6a9-4177-9b2d-7d508d5451d0","1ad3933b-4741-43d8-8783-cd51ebecacbd","2889074f-ec8c-436b-b0ce-cf655d7393db","365f14da-8631-4d30-be69-0bf702fa71d6","00c61931-7a19-44af-bfb9-98a81e695261","0d0a5c09-eaf8-4c2e-a3e6-1f7fd8980c70","1adc08bb-6173-4a8c-9bb9-9a60e450ac07","289acef0-7b98-4c52-8ff7-b58fab39f1dc","366122a3-e4f4-4dec-a96b-cfccb90930cf","00d26254-52f3-40d6-9baa-cb48031bceb4","0d0c341e-ecd1-4fe2-b415-9b91a241a22c","1ae330fa-85c9-4cf6-9d32-599e2020d194","289e8122-e804-4be1-840b-944af8aae2a4","36671da3-1e06-45db-90cf-aeae5f415433","00d94e79-6d54-44f9-9961-0c32bbf9fe3e","0d0f9d95-5d6b-4885-84aa-7ba77c117d2b","1b0b8a62-3922-4157-a9f1-c3de757762f6","28a0f944-f083-4b55-a37e-1bd0469c96be","366d2339-5e1e-46b2-b76f-4485b77c5981","00e6df8e-a149-440c-8ae3-524dad043284","0d26ecb1-b9e8-48a7-9619-40c082489100","1b15f30c-c025-461d-822a-4eefc4aa46b7","28bbd23e-f23f-4f75-acae-0bde8e19c0b1","366f1911-1dee-4bef-ba59-e39accfb9819","00f41e08-cf2b-4532-9b81-fab9071270ae","0d28dc42-0581-47db-9d8d-e8c24703ccd1","1b1e97ae-9a5b-4ed0-aade-2a0d186835ba","28c1f52f-4a39-47fd-9125-e470f43a6888","367202c0-9cb7-4278-a001-4d0313fe4d01","00fbc2ca-d65c-4f42-a86f-c79efbcf1755","0d30e31f-526c-4652-9ac3-342ff158c3df","1b2c7f17-75d4-4d8c-b26a-d182643b915a","28cf3ab1-b006-4ed8-ab41-a72066bcc5a4","3689b60c-12e8-4745-ba3b-06f459804689","0109e028-f5f8-4359-8640-f8bad502b1e4","0d310f01-de10-4b40-af43-c07743800beb","1b33802e-fa88-40a4-8526-80e0c14c05cf","28eb8bf1-6e81-44ce-895c-d3a4833176bb","368ec49c-7d0f-4887-93bc-b1323256ea83","0112b2a4-ecfe-41de-bd2f-d7ac6a84ca88","0d3197d0-86fd-46f1-b59c-46a0c1f74096","1b3554c2-0413-47b4-a354-b8c09f041112","290ad405-d67e-4c67-a960-d248767dbe20","36a589f7-39fc-47fc-936d-ff24f32c225b","011320a1-5afb-4bfc-8402-a803bca3af11","0d36b722-f187-45ba-92ae-fdb5bc465e30","1b35c561-071a-4df1-88e7-40609f662d07","290d02dd-9263-4fe3-9c16-b5155ab2bb8a","36b13b97-d755-4f6c-9c87-d1f85721e982","0115979e-df48-46bb-820c-7cb004d48d97","0d3bd3e7-1e97-4bad-aab3-25034397c115","1b3e3cb6-265d-46bd-982e-cbb416014dc0","2924492d-c33d-4d4c-b2ce-61d9f335a06a","36c071ac-40fd-42e1-a3c4-4919f9be6a29","0117e647-3432-49dd-bba0-01da86dfb292","0d49cb4a-27c2-4f60-8463-4a0821cd45df","1b408040-7f5a-4b62-af70-dc3b11f49fed","29339f72-6f1f-4920-87dd-35aa90f840cb","36cd2fb1-2720-44f8-941f-e269381a14d1","012258e1-0ce2-4877-a844-d4850d0654c2","0d545916-b402-47c8-afcc-f1be7f24bc9f","1b43474e-c8e3-45a9-8f23-4ff7db0a42f9","294f5ba8-f717-43be-81b2-65dd35c14e3f","36e32fb3-c466-428d-bedd-7f80d32f4b5f","0127bf9f-7e83-4aab-aeb9-edb1662274ce","0d564312-c6ca-4333-921a-0027f8d812aa","1b44c405-e624-4991-8903-0e7f9fba7a1f","295689b3-5189-4e9d-9da0-f717bf7c88b5","36ea994b-5e36-4aec-beb3-d6feac5b2d40","012b9c7e-7940-4893-8bb4-3b7f8ec18856","0d5ea483-52db-41d1-9179-2a01b0189ce5","1b5aeb30-687f-486c-9024-21635dfe20ad","2977e1f2-62c8-490b-927a-6fe9f7af07f9","36ee8b17-72e8-4e3d-a57d-82cdb461d201","01302721-b9ae-45e6-8667-6b262b5f03e0","0d61d08e-ae7f-4440-b055-c3f0c3091daa","1b5ecdbc-c7e7-40ba-8479-496d4265ffc6","29857d9a-5f78-4f52-a660-47b54c45ea69","36ef4628-df31-43a4-9223-dac723d8e46e","013aad90-2127-4b73-9cd6-63a1dc0abd8e","0d7ac6aa-ddd6-442c-9a51-f19362721096","1b79be3b-4f84-4188-bafb-debe93cc9724","2986b4d6-f80b-49d3-a4d6-99b8c1a90a7a","36f1d458-514e-4915-8e66-68da333b7553","01516dea-3099-47cf-be32-0888fb5c0e69","0d824321-6a49-407f-81e7-f3272f1aa03e","1b7a1411-7d2a-4b75-a44c-923d20212bd1","298e2e45-4a3e-41d1-a723-f64145403662","370da56b-3836-4f97-a4e5-375e5d09bb4f","0153a6d2-bafa-4f6f-9a63-129823d435db","0d88db04-5147-44e6-b32f-965f67008e38","1b7eeff2-3f3e-45f2-a1d0-b91d606b0fce","299b9000-0e15-4cfa-afb3-f0e641cd802c","370f1026-044f-4d72-be63-e4528fea04ae","015dee50-d9f3-48e0-899e-1b445aca5ad2","0d88fe79-9db5-42e8-bce0-ea62f2d8e1b2","1b99a203-b879-469a-ab94-eeeedf05de82","29bfe835-7cd6-496c-acb3-368ca853bcc3","3714b5b7-35fe-4967-ad5d-46b4e0146f4d","01671cb1-d34e-4a99-885c-1bfa09bd0950","0d89dc1d-0688-4253-b788-d1c228d93892","1ba0bc99-18f6-4351-9c01-b6ad558bce6a","29c2ca73-600d-4d7b-84d7-84bf429bb74a","371e8abe-fbf3-48f4-8cde-f844bffdf678","016cf394-f789-4cff-bcf3-dbc8c1ab7ace","0d955a83-4f6c-4fe3-a65e-3236876986b2","1bb90fca-939c-49c5-8653-97f576d2e336","29cd0840-a3da-43f8-b755-86d0e5ba40e8","371f7feb-f80d-4df7-a513-7446e65bec48","01733f68-aea4-49c2-b908-e29a12b05f9f","0da86cc4-2305-4bf0-8df2-4ba250acdee5","1bbe658f-ce91-4dd9-bffd-7377259caa1f","29e6b43f-7149-4da7-b1cc-7c8886322cbd","373c4d7e-757c-4aa3-8ed6-bf86d1c5cd23","0193061a-06be-4faf-a5e9-7362a2c5070d","0db32267-df2f-42d7-bbb1-3696f5519105","1bcaf3b5-eb40-4d15-a1e0-d228cfcea3fb","29ff3aac-e24a-47e0-bfee-e802124ea057","374820b0-7836-47c1-bfe8-9490d1bb6036","019b6a32-f809-480f-a485-20e77f2760dd","0db64800-123e-4025-a5a1-e137de3dfcba","1bdaa0ce-179f-4106-b5b9-05d78e4d7935","2a088e25-a76c-4016-aa47-eacfbbc43f61","37533933-c0f4-4bdb-a5ce-54efc1972911","01a231e8-22fc-4aac-b2b0-1f3aa2812fe3","0dc5fbb8-a9c3-4414-91fe-a2397ea3b7b3","1bdc62a3-d4a3-41bd-82e3-f12f963cc7ba","2a0adbbc-6f8a-4ee6-8cbb-e635dc946f78","3758df91-f9cb-4e2f-be69-c16c5e073c01","01ad5b63-8b5d-4084-a13c-7954b2f99212","0dc69a0b-ef1f-49da-a0c6-01256edd7c90","1be54dda-d89d-4382-a011-f63ab27854a3","2a1ed1d7-8600-4826-bb6f-c5b011ef94c4","375d5166-2c7a-4210-a39b-910549ab9c0f","01b4a3e0-5162-464c-bf1a-a174f002afa7","0dd38ba8-b33a-4ccf-ab2a-667ae58a4474","1c00cedc-e0fb-4f47-bf48-97c12ff3f97e","2a3f6c85-9ff7-4322-affa-dfff32141611","3762b6e7-2b8a-45bc-95a1-d27006b72d62","01da4aed-8957-449a-9e4d-3e5416ffc95e","0de1b7b8-4da0-4409-853b-76900192419a","1c0f8d6a-c864-4c0a-9d87-0b96eed3e123","2a57474c-ec8b-4612-a702-3f76f51f8274","376d3c22-db3b-404d-87fc-b8c2d648c105","01dd4f8d-e303-49c8-a05d-5e0a3f0f74ff","0dee4a16-2fbd-41d3-a777-9158e539bd21","1c10b206-565a-499c-9fe0-4f37b6152b36","2a7fbc11-a577-4d29-a799-ff21b39cee8b","377c21f8-39f4-4377-8950-810391f0dd87","020dd5ca-2297-4e42-8b68-4790ed9a0c75","0dff437b-5c1f-4514-9ddd-11e9541a06f0","1c13bdb8-e771-4b40-b446-f021612c15f2","2a8119dd-3b76-43cc-9c12-8b2400ed865c","377faf87-545a-4bb2-9399-5eb0613ed5bf","020f80de-37fe-4e32-afdb-b9f51ba207dc","0e05e405-7694-43aa-ace7-9af40feada5e","1c217a4b-ca7a-4158-b4fd-57720f37a5c0","2aa334ca-1673-4d66-95b9-e37600ef63e9","3780f294-f1ff-4580-8eed-47e85963a172","02176dff-9e7b-4ff7-91b2-60146b9d662e","0e129b86-d158-4099-937d-fb5c6bb9b37f","1c38118e-0204-41c1-86e8-0fedd060e6c0","2ab3c701-5d44-44fd-873b-cccd7cd8d8f7","379ae3f3-9c64-4f90-888f-a790cdf558fd","024bc1f0-b2d6-42f4-accb-a2a55578cf98","0e1d394c-4af3-4564-9d5a-172aba7c19a9","1c3cf378-4fd9-4127-a7e6-1d50425af206","2abff164-a5bd-4efa-b880-43c4d00fe0bb","37ad3904-e75b-48e2-ae70-ffb156a4662a","024d6d34-7c7b-43cd-9dfc-2e27cae5f4da","0e5cb962-1297-4b13-8e93-6830fdfb6c05","1c476bd7-2506-441f-9e35-88d4429e2c2f","2ad5bcfc-e8a3-4ad9-bc86-2f8dc9b281b3","37bfcc38-069c-42fb-ab5c-a9472858dc9b","0257c53b-e306-4969-9157-a96c55ce61e8","0e6acd33-b348-4b80-8202-ec66c8ff580d","1c56d644-9998-44cd-8ffb-0eb383903784","2adb72d5-e56f-46d9-bc31-ca141f4cc305","37cf3aa7-8701-403a-ba70-b9f6e80b5d23","025e4cd0-4d3c-42f3-816a-50e19a75369f","0e720d2b-5516-4351-a55d-cdffb1f1110c","1c5a43e8-26ee-4f95-b894-9d589ec79c10","2adfd6de-fee5-4992-afce-f0391df3ae32","37da2b9d-9662-40a6-80ec-997569a30559","0268f071-5fd2-4636-831d-179a2eb0c79c","0e82cde1-0e44-478c-8183-81715b60cc49","1c67832e-3b9f-41fe-a91f-9c5a2b3ca104","2ae1b1ab-2fa5-4f3e-8c7a-7ccfbb818604","37e8f8f0-3942-464f-b094-e6972604fec7","0274dad8-b896-4b5a-b4eb-b7084bc9f3e9","0e9e1fb5-7860-4e99-b33e-45c2c39d7c3b","1c8c3824-0f3c-421e-ae30-fa0ccfaa0670","2af8b817-08a5-4dba-98dc-9f9f095ef071","37eb989c-9cee-4eb7-acfa-b56e2c841516","0280c1df-84d7-48fc-900d-5356f7b24c20","0ea86022-89ee-492f-b413-2049a511c298","1c9bbb2f-df86-4168-af26-87eef4a4ae9a","2b12f648-4d3e-40be-9666-b6ac550b7391","37ebdbd0-32de-4d56-b77b-1469572e493f","02ad2970-6aa9-47c7-bb24-73ee399defd8","0eabc427-546d-448a-a7c7-79c071aef5a5","1ca9da7f-049f-499f-b9cd-527491d019e7","2b138815-41a0-4e83-960f-b53b40544943","3801166e-733c-4368-b5db-0945e958a63a","02b65185-e73f-4e9d-bd35-001e2dbe1597","0eabfcb4-10b6-4d37-b2dd-c08154e9d23d","1ceba973-2f04-4729-9530-fbf45385e337","2b25f13e-a538-4758-9342-cb4ee1d73194","38078193-17da-49c1-944d-c339ee83221f","02d0746f-2335-4521-b684-d31dda197ed0","0ec14e9f-f338-44b6-b59e-a8f987d05461","1d09f2d2-701c-49cb-92b2-d9d80a552967","2b395b92-e49a-40a4-b432-aeead914af70","380de0db-fe7d-4d8d-850c-7557b4f51556","02d3c342-2172-418a-b572-4bd65ceb5820","0ec33872-794c-40a8-8bd2-fc1c41d5eb35","1d0def9c-e562-4940-9a7f-f20addd3ed3c","2b3e3292-4b5a-4dc8-b7ba-05a520fe27e9","3815eafe-72fe-4d87-934c-bbe582762660","02d45957-ad80-4345-9339-9239152e3dec","0ecc37b9-d1b1-438c-8dfa-6fe301e790c0","1d295096-8f00-4fa6-930a-f88d5ab9b522","2b460332-593e-4aa3-b25d-00f840b8b6f3","3827ba71-ade0-4f37-805b-d59e03d9c285","02eca796-0b44-48d7-9259-371d2e6ce363","0ed2944c-91e3-4b0e-a303-e13a50f12012","1d3a01a9-3c4f-4485-9adf-df8a9099e707","2b808b7d-d2fc-41c9-861c-e6331c2a3cc3","3836b789-7122-425b-9cef-b47a90021311","02f022d5-9a34-4d7f-b7eb-d0c9f24ae031","0ed30cf2-a893-4f73-9602-49e964d3d8dd","1d52cb5d-b9da-4317-b8a2-88c9403cffa7","2b93fcf3-8c38-4c6a-8ac4-3292c1e93ded","3837d4f6-22d8-4dd2-81e0-18fa00554e82","02f66acd-a42e-4d66-bf5a-e624be1ec9f6","0eebd7c2-328f-46fb-a82f-7ef5d00489f7","1d5f5c87-c5bd-4d3a-bf5c-998f1b9dc016","2bbbb864-fcc9-4bdb-b27c-d4daf0516ad7","3843cb2a-fca9-42f0-9553-5dbb153c4dc8","02f776d1-97de-4220-853c-766f8f91d4ae","0efc5e54-b157-434a-b6cc-f9f178d60d6f","1d8b6826-d7ae-4de9-95fc-b7f2b4b109c9","2bc52b5d-42ad-49f2-8f05-3ae96ecb25ac","384ccba4-07fb-4923-8fb8-47277b50b1d9","02f78ad3-4281-444b-a6a3-7e3b230a3bb2","0f1c239a-9bb2-439f-8f52-00f340e855e9","1da4bbff-df28-4be3-ac14-f714fce4f0ce","2bd007d5-0c48-4106-89a9-416dabd3995a","3854e5ce-edc5-4b43-b0c5-c15cc0e23217","02fd8452-d409-4fa8-ae88-00197d831895","0f2fc9c1-8911-494e-9c09-1f3d6312e56a","1da9ed80-bc18-471b-8800-7a080e82f156","2be12946-a32b-413e-90c4-c672d2b693dd","38856988-b824-4680-baf1-fd63ee3af10c","03057040-5731-411e-b0e8-f1e75ea13dc9","0f49fd33-6ed3-4b92-87c3-251ab221126a","1daff45a-9001-4bc6-9186-34cee04fc895","2bef23de-1f7d-45e1-b851-07a33d5536e2","388fbb85-3816-4266-9aa4-0985f02213dc","0306e6b0-ef24-4b11-957c-e3be0f082363","0f4cf9cb-b15a-4e41-a9bb-d1713521c506","1db4e18d-e425-4504-8436-f93497e748a7","2c08b318-2f50-4984-8c46-3c8f441304bb","3894cc7d-cf34-4e59-a6ef-023d69837c57","03276cd6-592e-4dfe-a892-459a995985ae","0f4cfec1-0ba8-4517-927e-f4744359bf89","1db83f90-b21d-45f1-8028-de6fed46d545","2c16f689-44ab-4bd6-8c79-dc1f9a62ab20","389b2361-a0aa-49fe-ab3e-fd7ea447ea30","032b5eb8-504f-4da5-9fae-e777c9e19834","0f5d38b3-7c3b-49b1-bcc4-cf901114406f","1dc31b9f-cecc-4fe4-9753-f1ed6988dc02","2c2e7b61-b493-4810-a149-1fc832f7fa26","38a183f9-71f7-45dd-837e-d2a33f4f8f95","032dce83-36d5-4cc4-8001-df19c9316a2f","0f5d5339-b418-407e-9aaa-86217c303052","1dc5658e-74c5-407e-9c9a-265025e65e02","2c389e10-ba7e-431d-8a93-4cf29fefc9e6","38a4d7f9-4534-42c1-8757-6ffe049e33a1","03315d3f-994f-40c4-b25c-4e5253d169ef","0f639ab2-113c-45b2-846a-e151e4d6e902","1dc86dfd-68b3-4e4d-81d4-cd74df25d74e","2c4f873a-dca0-418a-81fe-f7b3510e27e9","38b0bd36-2ae1-44e1-bf07-12741c70506a","03446483-0d70-46c0-b73b-6475c38f8366","0f6d7a4e-f85f-498e-bc28-d4a4714156b9","1de99cfc-3ed0-4c92-aef9-29258a34932c","2c5e11db-df0e-48bf-86c6-a5ebda4e4684","38b5e140-dc17-4f18-a70f-7f540cbd5492","0344b2d4-50aa-4c1c-9818-116f82734c2b","0f74b5d6-f0e7-4736-88d7-99f9d7b30b91","1df0feba-d939-425c-bac0-c7a051496a3c","2c688db7-d9f4-43e2-afb4-52e3d4588c69","38bd845a-619d-4f3f-9ead-3af8904d59f2","034cab81-de5d-47aa-a93b-b4cb59428469","0f9a47f8-c6bb-4867-abd5-3a3a9d90cc0b","1df15ab4-3be8-4c5b-a8c7-90c30733ae9b","2c69a954-abd3-4d00-9004-0f3aa134bafa","38de3af6-5da2-4022-b740-1593c31a9c8b","0362fd77-a434-4df8-b40e-3e40fc0dd6de","0f9bc0f9-ce6e-4293-8574-45ae55730417","1df2181f-9e2e-4780-8d2e-c762d4077bf8","2c6db8d4-0266-4bb8-ba3b-6bde654ac5b5","38e5928e-9529-4740-841d-02e532deda19","036a51fc-64c8-4c32-a092-b5e499b6c5bc","0f9bc8c5-dd79-4fab-8034-f9fb41ecabb9","1e043dd0-f302-4696-a705-45b9cbf3fec9","2c79db6f-7aea-4223-8004-66fea563a889","38e87c3a-d493-49e3-94d4-38288f880dfe","036b31fe-67f5-4b72-8c0b-d560c4cdcbeb","0f9f39f3-6cb2-473b-9192-8f6dc63a6f4c","1e047176-e83f-4f64-8d11-f24780486ae5","2c7e5c9c-293f-44d3-9096-7b0364456bd7","390c6b65-046f-44c9-888b-edba091f90f8","0372c7d8-25de-47c1-b55f-fedd644dd02e","0fc9f3f8-1357-48e6-a8e6-99cc58a564d5","1e0a2b34-4d8f-4a65-b41e-33353726e588","2ca4d19a-22ad-473c-bff3-3b3aaa3493d1","390c9cc7-1e6f-49a4-9bb5-bfa8e6200d0f","03a39a67-070c-4d6b-9958-6926882357a4","0fd44442-8ea7-4432-a3a5-cadfa9aacf64","1e18113e-33a4-4095-9dab-7748d8946b03","2cc09667-fb24-48b0-a68a-c2d98ff0b2fb","39110213-54f5-45c3-9051-2d8adff9a2df","03b9bcff-4bd2-4de1-ad72-8c086c1f47d3","0fdda26b-fe24-4932-ba32-6c902b947326","1e1a59e0-261b-418d-a8a0-ec82d99ffb86","2cc50eab-becf-4791-8ce9-9038f92439ad","392f867e-580c-4359-a027-b218af8a53fc","03be066d-eb9d-40eb-999c-eb26c56a2429","0fde3df0-9921-4dac-a963-03119821cf0d","1e2721ae-98a8-4711-bf54-bf4d41fcfd3c","2cce58c5-65ad-47db-9fb0-ab13368730fc","393fa8b1-21cc-4029-bd02-d00c2c6cc04d","03c942a4-8d3e-4948-a8af-07239338ed6e","0ff55f23-164f-4da0-ba17-dc91af7b0fb8","1e3602b5-7301-41af-86eb-2e8d39a182c0","2cd49c23-88ae-4832-a984-a79c2026319d","39518bff-f873-468f-92c4-38d2f52acde5","03d90386-78c6-418e-8cfb-18da02d2042e","1010e2be-68b3-448d-b6b2-82c2505589f1","1e37b780-a29c-4c59-bb21-53cfff4691f6","2cdd5fb0-0cd8-4b9a-bcc2-72e18b3c5173","396bb5df-46e5-4a30-8400-95bfda6024f2","03dabf55-39c8-44b3-8152-13fd7a2ef5a4","101e3535-e7bf-423d-84cf-252450b39dad","1e3cc75a-8c03-4721-b8b9-b6e1265112ee","2cea7edb-00ac-4008-be62-39d88982983c","398a4736-537e-4de4-a802-bd0f9a0a5e1f","03dcfa5d-b1b1-43e6-883e-d5e40c5ea55b","101f8b2e-748e-46be-8c79-6c712854bac4","1e40805b-d58e-425c-9d26-91c5d0ef62c7","2cef193c-89e8-4d19-922e-5da5a7216a5c","39903529-a111-4e87-8ab0-1c6042403ebc","03dd4e99-1eea-4a4b-a7aa-ea39801d1b01","102d8b86-eaca-4eff-afd8-1b7e0c3cacac","1e44770f-73db-4539-8334-7460ed9446cd","2cf874c1-ef4b-4f5e-a742-33aaab5e1131","39cd387c-853e-4fca-9153-62b6eed54024","03eacf60-5c7f-4aaa-ac40-6833be40c8af","103d6baa-4535-4329-9ddb-8cf5ed83e9af","1e474857-56f3-4dc0-8871-181ec6cd3a3a","2cfcb5f2-4b58-4e09-877e-20d61b603841","39d138fc-0ee5-46ad-bd3a-8e5a38bda3ed","03eecf7a-b5a0-4080-8649-766ef21bd611","1060cf4d-9a69-4b8f-904e-bb95367d3ad2","1e498af5-9eb3-48db-baa0-379e79d91b37","2cfff18f-72f2-41d9-97aa-36457ec1ad89","39d311ff-e6ad-4fbd-a8b9-f0fb55248e1d","03fafb96-35d8-4118-8998-413671994ced","1063a477-aa3f-4d70-992a-36e66ef1a3e8","1e4fe13b-60c9-47f2-8d0f-4051b627224a","2d069e18-3a97-478b-a6a0-4b27abfadcc3","39d9f59e-0519-488f-bf1b-222e5bc43c89","03fb3ab1-096a-46ff-830e-af69cfdc4dd7","10757a94-66b4-4444-b0f1-893da7fde41c","1e6cdd11-f535-4ab1-a943-b77a963ae98d","2d0b5acc-ac75-462c-bf41-aaae4dc30308","39de150f-17a5-4a35-bd59-a2e2e2720b69","040ec018-fd57-40cd-abaf-b03211895c92","107b75e6-b43c-4fc7-a9e0-44ef1daaeeb4","1e7f1fa9-2628-4531-ab21-8339b2d1f454","2d3b9107-7857-4e09-904e-6869b9ae5b15","39e0f7a2-8be1-4473-bd02-2147e12216bd","041ccd2f-7515-40c6-ba07-755e1491954f","10832d04-c7e8-4deb-a5ee-89b92ab273fc","1e843213-cf19-4fd6-bcf9-8ee17ad8d70b","2d495c51-a5b7-406a-9e3d-baab6e89762c","39e5009f-c25c-4622-9c37-c7cb7be8c1aa","041e2282-1bb2-4e4e-85ba-84f369af5dcb","109f0eb3-f63b-483e-b11e-dc4bc0bc4d7d","1e87c923-cc4e-4cd0-afd1-60e5c9271650","2d6293bb-3eee-442d-966a-cf6dc57ee632","3a027116-c16a-4342-a599-d54d9520ff56","04289080-3541-4b41-bde4-289a2134f342","10af795c-3f9d-48dd-b1c9-52df69e0ac44","1e8cfcf4-6eb5-48fb-b11d-f92f491b7c1d","2d6979f7-83b0-47ea-a26f-f50205d9ebc3","3a0b7ba4-38f2-4279-8384-6002d35a5bed","042b5809-0a93-481d-bc71-302a408c5aa8","10c57a26-f595-441b-98cd-4ac1e4fddbe6","1e8e4d74-0ce6-49e8-83bc-92087254d18b","2d6dd755-70ab-476f-9fce-b8792d4b5932","3a101302-8aa7-4883-b847-adf3e6b8206d","043164f9-f37b-4210-bef0-6a208d48bbf4","10c6ac8b-106a-48d4-a8d7-8b7f37fb6e03","1e9af3ef-46bc-4781-9f41-44d839457be0","2d70f666-c0cc-4e37-b630-94aec83a5a63","3a147f13-0a6f-44fa-906c-ec719fe7b317","043710a1-617a-42aa-8270-9b4432560027","10db1ed9-89b1-4616-b641-b561ff49c093","1e9d8b8b-2714-4d0a-8ef1-d682b5c132a3","2d790746-9074-40e1-82c6-2fb8fe4b512b","3a2a6c0c-5a07-4d94-b208-ac3d6bb227f7","04445fd0-a458-4271-887e-5a4b2fa6700e","10df9b89-01da-4d5e-aa9f-fa700509a348","1e9fc9df-2c59-496f-915b-facef9859fb9","2d84f766-005c-4989-b630-60a597c8e04c","3a2add34-ac61-4029-b997-67757b4fe03e","04454826-c403-40bc-b466-aaf92c8439c9","10e9680d-f76d-4975-ae7a-2dd2a9c79c5f","1eae27ca-0252-48ae-b2d2-ef3bf08950a3","2d8fea6f-5334-412f-9862-561d02aeba03","3a30b32d-3ef7-490c-a2da-2e0f0fdb938d","0448782d-2757-4668-abb8-56493d2fae90","10f1a891-6cd1-4773-a031-7c7db882212c","1ebb56d7-a1d2-4dcc-a0b4-2b44a3536d9f","2d916ea0-2d43-4dbb-9055-19f140a45dcc","3a362c86-90a1-4ca6-ae26-d3ccee4a05d0","0479e22f-aa89-4e05-9621-952dfadee3ba","10ffea97-a652-483b-979b-a380f5da14e3","1ecf9a55-b978-4427-b9a4-6a0cf36832a4","2d96ccac-7691-4eea-823c-3be55d181f9d","3a4a6b81-b1ee-449f-972a-04972e94618c","04830847-d368-43da-8d27-6daa510096b1","1101e1b2-0a18-43c1-9d2c-a0d284d96ee5","1ed04e6b-595c-423c-bc97-ecb146c44425","2db09021-d85f-4b1f-8260-1ac743f2825b","3a6b266d-a15a-4e24-b898-a141d0cbcf30","0490e403-862f-4055-b770-afe50aae388a","110c2263-fc20-451b-8ffd-6359cbe98a18","1ed54354-78e0-4f87-85b7-7225b5e07449","2db7a477-735c-4ace-9d9a-9c222b542f03","3a9d2c15-5e72-4d2f-a897-ae95c997f0ba","04b25478-2972-489c-b0c2-d3488222d132","1135083a-a31f-48f5-bb73-a0c3dca01611","1ee05886-19ad-419f-abc2-4dd120068b88","2dbcb9a9-8af8-4fb4-8fb8-aa4833cbe8db","3aae1e48-dca3-46fc-a333-c71d02724825","04b48681-63bb-42b7-8735-1a926799f6a8","113579ca-1ad1-4ce4-932f-702ac9e3a141","1eec85bc-35e9-4091-a2f1-d3965f826d60","2dcdd595-dccd-4be7-8f2d-9f61af7f4b8c","3aba61b1-4b6b-4b2d-a064-198579460ac0","04cb0436-e78d-42a2-b180-3a7a278a04c7","1146c1a3-589c-4ddc-8fb2-4457b3936a53","1eed2f5f-efe9-4c34-bf95-06b689645536","2ddb90cf-566e-46b5-b654-961d78ece734","3ac083ca-8c5c-4751-8f5d-98126b5d4d1d","04d8fd07-aeb6-4256-8606-c6610b14725c","114a6dde-e185-4082-918e-72e6ce724ecc","1ef25b60-81ec-438b-8bc4-8563bd5e1dcc","2de94902-9c4b-4783-9091-3d948927ebd0","3ac106b4-0fd1-489b-9109-d33d2b7e9b70","04e83314-7711-4f6f-90a2-8760a3959900","114ac294-510d-4fc6-8219-16300da0ac7e","1ef7d722-fad6-4055-9d20-515ef412e4c0","2dfdc423-2594-406a-b2b7-1e620bd5baf5","3ac7ea2a-8d3a-4bda-b640-aa6d124f7794","04ea90ab-0efd-431a-bb77-ed7ea090e056","1165f499-93a4-4eb3-a61d-9bbe36a06f08","1f01ecbe-e363-4b5d-a006-32ae19dd2be8","2dffed0d-10eb-4f6f-82ec-62f84dfc7b57","3ad6a13d-6110-4060-bc14-5a8c4aef1c14","04f33baa-d3ab-4fa9-a639-9c0984de1d86","118ea617-0442-44a7-9e8f-0ee189dc1ba2","1f075580-26b9-48c2-a7f6-f9ac1957550a","2e03bd2b-eb11-4f6c-a7c8-97ccccee727f","3afa8c21-ba39-40c1-a24b-46840a9ca0b5","04f8fd1a-8f04-4c85-bdcd-646ec59918ae","11999483-a2ce-4969-8a41-04c583c5d6aa","1f2176ad-300b-4899-bcd6-c4304b0a66c2","2e2439db-99fe-48f1-8643-8b361a88b475","3b109dd9-939f-4dd1-96cd-7b86466fb763","0500c8ce-d2b7-45a7-999a-6f2468330e07","11a83433-61a8-490d-895f-5c2dd64d483d","1f2e7cb1-6143-4c4f-a82f-85a9b89e5675","2e26a194-9d07-4ece-80c7-03db61157b93","3b153edc-e005-44b1-9045-2f72aa5ae2a7","050415c8-0c87-4905-8f00-f95140a15cda","11b4d185-2636-4abb-be8c-d1a6d8e4202a","1f410d98-de15-48ce-830b-2c1a9d76daf3","2e2eb536-962a-471f-bf2e-d65c0b4e34de","3b3dfe82-1372-4a55-8d30-b3c0a9fd7d3c","05062963-e0a3-43c1-a02f-efe7b1425fdc","11c01051-e1ad-45b7-b846-ae071ad05491","1f5a0e4c-42bb-447e-995c-28a5621c4383","2e3c95c8-101c-4388-9668-0d82903882cf","3b4eb807-9fb2-4e00-af6b-5b8bd5a0d516","050776d5-d049-4e43-99fa-47f21e862eed","11d100c8-144e-440a-85df-eefb5273381c","1f60a160-3d0c-40ed-a588-0b35c6f969c2","2e3f53b1-5592-43f3-97d1-228ac8342ccf","3b5d5e7d-4381-4b91-8d94-272cb72df9c7","0508c742-d812-44b9-bcac-a33f8c2765da","11d33a12-db49-4023-8142-6daf2a192502","1f623470-5d92-480a-9ed9-110046f0c920","2e401168-61cf-4b40-9704-e60fa332e536","3b5f297e-68a3-464d-ad39-f2c0d6423bb0","0514534e-c822-4340-ba64-0131010a2c15","11d92aad-77d3-4751-b12c-103737542665","1f69348e-2ea7-4a0c-b65a-37ab11cc0620","2e45b024-5bf2-4dfc-825f-730ffd562577","3b660d04-0c4d-4b24-abdb-375f6c2a501c","051668aa-7ecb-4977-bbbc-af84bdb9a9ec","11d99c7f-1e4e-42a0-a70f-ae3e46fe3a3f","1f7115e2-a498-41aa-957e-5490479a0c00","2e491c35-fa4d-44fe-99ce-f7f6cd28b1bd","3b700f07-4984-4dfc-9b9d-5ab7789bdc86","05197000-1ff5-4adf-baf3-6aba13ff8fe2","11e4ebc3-d8d5-4d0e-a299-7aa3a3f8fe84","1f757916-610e-486b-a2f3-3e62c612231b","2e522e82-0c2b-4d87-8fd6-44417391796b","3b8822f1-6b4d-4f11-89c6-a5891ad6aeea","051d77a2-cdef-4ddb-90b5-455d41ee6ed7","11f94667-d407-4dfe-9cec-97ba64e4dcdd","1f793a41-2a58-4ac5-a892-9d5ff7f465fc","2e54d522-2671-435c-9496-e047e124cd65","3b927dd1-93b8-486e-9524-e3cd498c2cdf","0523f875-61cf-4cf9-90ea-949321c2d3bb","11fe4c5b-b506-4104-a177-d9a2c24f99c1","1f7a84ba-1d87-4913-9b3e-f52405071e31","2e6857e3-3870-4b00-b67c-c32c95b1009e","3b95e772-690e-4389-bf5b-cba4f2642357","05247a39-d334-40db-8929-aba3462b6141","1200fb28-92e8-4fd1-8005-5e32346b4488","1f941137-5b09-4fea-b782-4374aeca6f2e","2e7b51be-940d-411a-8fa3-44b69c7ef43f","3b985616-5efd-42c7-b374-38ea8bb6f8b5","052797c1-4dd6-4be3-bc99-5c07bb20fa96","120af1e9-16b6-49ff-a93e-f51032f5cbc3","1fa0df7e-7665-4aa2-b63c-f3f15f2f0270","2ea39ffd-af86-4d1e-91b8-020048ca05be","3ba816ab-2113-4bbf-b0c9-cdaec2ee0874","053c5902-5a7d-4bac-b8b7-d8c8ba8e2c7e","121bb929-eed9-4164-8c0b-e8a2ae4f4600","1fa11e16-beca-4d93-a1d4-ace278aff2db","2ea3f93b-b4b2-4d71-a1e8-1fae7bc26ff2","3bc2cefc-cf42-477b-9728-67b460a730dd","05430fb5-a75b-474e-bb59-71b55b7a8009","12302e2c-be5c-4427-9feb-5300b1fecdf5","1fb764ba-8671-4e8b-ac1b-35ee340117c1","2ecaefa4-859a-4048-8e64-71c8f59fa5a4","3bcd93b2-a311-4fa8-aed7-86c1235862ed","054a6ced-985a-4b93-a117-c6ea5f26b672","1232b6ba-9bf3-4365-9fff-59f92467581e","1fbccee0-0d09-4f0f-816c-bd6127e64913","2ed5fe7a-b563-4b8a-af59-ee27988bbf68","3bee3ff0-d859-4e75-afd1-9a8a9929f379","054d3681-8b44-4f05-904c-353661680824","1236868e-f1b3-4d8f-99eb-556a67a55e17","1fea4d5d-a758-4515-98c6-380a8594c922","2edff9e0-a425-4b55-838a-957dd20a9b43","3c101611-32bb-46f1-a69c-cb71d6ba9cf0","05508944-3169-4c2a-be33-d3a02cfebb83","1256e63f-48e7-4d8b-b28e-3ec27444f002","1ff6db3b-dbda-487b-a7c7-3abb1598923d","2eefd5da-3005-4669-9f84-ddd4125e5846","3c12672f-a9cd-4b0d-83b4-e7aefd66bb41","0570d05f-cded-4dbf-9f7a-1c03272131c3","12584008-1704-44d2-8bfe-7267c774ee69","2017037d-635a-4b64-84d2-faa2b723c15d","2ef4c2ac-8dfc-4682-8113-84aee71fa4bc","3c12e811-f425-482d-96a9-a45be301983e","05726d09-9545-4f7b-abd0-947df9066ec1","12670115-b9e3-4370-8568-c20dd50dceba","202deead-46bf-44cc-b471-014df993fb7e","2efb4df7-8db3-4e3f-bad2-90970ca066c0","3c2fbfc1-df2f-4db6-97ae-81bc61aa9469","057b53a1-7d5a-4108-8938-a1f130f34158","127bff96-3cbc-4e3a-977b-bbb914ecbc0d","203dc20a-a1e5-4819-9644-c722332d1459","2f04d1e1-f2d1-436a-9b19-537bd9260685","3c3ec400-e66d-4cfb-9457-fa1228e9c42e","058979ca-1c4e-409d-bb48-35f5fa28f005","12821283-5498-4766-bed6-ccbcc72816c5","204970c0-1c97-4dee-8c37-235e1c4aa536","2f1b0aaf-5bc9-439b-a7dc-80e750c1288a","3c3ed2b3-b7a0-48a5-a626-91b4f1b42de2","0589f3c4-6410-4e70-8c36-0f4825952ea0","128d77a3-1b7e-4110-8636-7a9695cfabc3","205210e2-44e8-473f-a9b4-215d81d63073","2f2663e3-8cd8-4374-ad66-87196ff4a8a2","3c409d2e-808e-4832-83f5-d3d635103170","0591e55a-2238-4b80-9417-6715c12eb42c","128f1735-52dd-4f81-82d6-fca89725b1a0","205dfc83-7372-4dd5-9e87-bfbd96b96d5a","2f3a198e-322c-400a-8ca9-0c6a798a9059","3c454ace-23d6-4882-a550-425f35d67d9c","0594bf36-b8fc-4fc7-b9c8-0d830ec5d9d1","12960443-2391-4563-be5a-be1d6fd67e3e","2060ad8f-5660-48c7-a028-d5bb0eae8808","2f442301-3788-44c1-96ac-671c83fc8e0f","3c4db807-33af-4223-aed9-08740e2b108f","05a1215c-ca1a-4208-a3e1-632bd9528bfc","1296a24b-2342-4d49-8e36-ac99921d1806","207a9643-ad12-4620-ae7d-e513ec0dbf9e","2f46957b-13b2-44df-95cc-16dcf9c3ff08","3c4fd798-18ff-4873-9181-6508f7de90c6","05a74a9f-248d-45f9-a640-b8c77c7785be","129cd6d5-63e0-4562-b19d-444aae08753f","20a03aab-e9f8-46d5-b423-495fc00b9cc6","2f6dd4dd-0e3c-461c-a357-1dd7d6d73eda","3c54c8a1-4497-47da-be0c-c6e18746716f","05a75bf0-07b1-4f21-9209-a976fdf7949f","12a591f4-0495-45a6-a81a-b499e8b4902c","20afa637-5605-4947-a6a2-91271a09a5b1","2f7c3eb6-fff5-45d2-9967-6dd6981b40f8","3c5817ac-8b91-45f2-8619-0e2dd16012fd","05af61b6-8fd2-4cc6-b9e5-7379cad3b5ac","12a6d5dd-30de-4057-b08d-5a516a0cad7a","20bea82e-ea13-4428-92b1-b67f5ec06e18","2f7c3f36-7cd2-4625-bdc6-548c8078cacf","3c66cd63-99c6-460b-b06f-d53d359883d2","05b0ebfb-8f21-4976-98da-95c693d65f1d","12b5187c-00c2-4938-8782-840fb798c7aa","20bfdabe-0195-44a2-953f-a9a565e62f47","2f7d6afd-03e9-4155-855b-0fdfc5625b4c","3c687367-5b69-4ca8-aaa2-3e7a844f45ae","05b51ed3-aa04-46f6-b94b-d3d83c90625a","12b8c400-7b0d-40e5-90db-30d07ab5996e","20c12540-47c6-4cb2-9f83-42d9b86489de","2f888d30-09c2-4137-967d-27b542544def","3c8b486e-4748-4873-bb59-0ad4bfa6a720","05c21ede-0d5c-4ea6-aaa3-700f25a2de40","12b9c402-e966-4ca1-9026-11623f9358f0","20c34c66-880e-424e-9fa4-e156a24dfc72","2f93d403-7243-4312-9ab5-4dd729953a55","3c996445-39f7-4667-aef2-20744cd7fea0","05cbba5d-30d7-4f0c-aedd-e6f4cc83c476","12ca4495-6975-4761-a295-ef32a833ccc4","20cd17e0-5263-4dd8-a39a-526c740fcc26","2f98b34b-6931-4a26-955f-e27847aba402","3ca56b13-b556-4ab1-a7d8-160571001932","05d8e970-779b-4284-b7d7-35bff68eabbb","12d8f40a-a261-442f-922c-f1737d231ce6","20dc4067-b049-44f0-a715-cf995e0e4962","2fa6f0c2-b941-4a3c-a2db-0bdd868cd735","3cb19655-1fce-480b-b26c-d29f2cac78d2","05f6449b-b697-44b3-bbdc-e089a0d1fbcf","12e8ffbe-3486-48ed-b5f0-fa0189b2787a","20f49ba3-3b01-4d23-8e76-19a8daa33bcb","2faf378e-43ab-4576-8d74-a88a63e7462a","3cd49237-23f5-4bca-89df-38625ff796c1","05f741b5-a5c1-4099-acc5-28c7d9a7f820","13046202-14e6-4e22-a5d3-3881c5c52d8d","20f58938-5b09-428b-b707-c5f8e59a2d49","2fb05599-4d65-4f86-9e3d-5d4866d003aa","3cd6c05f-5636-4bca-97fa-59ce67f97074","0607d720-fe18-4fd9-8c7d-2b72be4c4488","13071382-2812-4df2-8998-07f0a10c6920","210da2e2-cdf1-48e2-b08c-afbdc2da24ca","2fc601a3-b067-4450-a3fa-4cd3df1303e2","3cd92a19-d6bc-4311-82e8-416294d05c67","06385296-706f-4f7c-8157-df41c3d2dc83","13168470-37a5-4255-ad3f-dfc3029798f4","21155e0b-161a-4cee-887c-e025b443ec51","2fd8f3a4-3fca-4a1e-9635-788653c55e46","3cdba051-e3e2-4691-841f-ccedff431456","063a33e1-821d-4075-93cd-8537c9490382","1320a14a-5c1b-44c5-a87b-ab2150a521e1","211a3cc2-94f8-4c4a-b9d9-3c0d6fe4dcb4","2fe66641-8cc6-465c-a7b2-49a446d106d7","3cf06386-4d3a-4e16-9584-d7cc267c2902","063e6fb5-b9f7-4547-8087-0b466fc05677","1322d8aa-5766-41ff-9356-fbcec50bd6ca","21208ed4-104e-4ae8-b3da-ebd9030b1cb0","2fe83b21-3e44-4954-896e-0ffc6da77d24","3cf21c3c-7c9a-4ca6-9756-ca179865994b","0645b89c-384b-4bf3-907f-276526c23b8e","1322fa78-bf71-4e13-ada3-f922509a2846","212939a6-eae6-4218-b080-33e792520711","2fec32c2-2fa5-4c3a-9831-49cdb8db6e9d","3d005956-9bbb-4331-99d0-4f73cec3c7ee","06482aa7-cd94-4f75-b100-13c1aa133d94","13250e0d-953b-4670-94d0-aa2c3b0d2dfd","2136fa76-e0ab-4413-8a77-0145ef4cc1f3","2ffec721-fe98-4c17-9cd5-daba103234c0","3d17ab7b-0cc3-46c4-9dd3-5c4b07fb9559","0651a70f-0204-4db8-aa21-1d939e71f818","1347989e-fd2f-49d5-b655-45a2d6af999d","21443292-02ba-4bd7-8ad8-5c2a8711ab34","300073ea-2894-483d-ae0a-8229abc42d93","3d2c86ec-2b78-483d-8403-ad16af09d389","065a1972-6d3d-4a6e-8657-c2d9b3025cbe","134a7717-d6a1-46a2-b5af-87d17af44c0a","21496cf8-edcd-4d9e-b262-4611460aae67","300cd85f-566e-4dd7-80d2-8cc8bc227219","3d337a4a-c0c2-4f45-b64a-825b7e1d6641","067424a0-6fd3-46ac-b84f-62b0392fa985","13762a22-4632-4bbb-a32e-7292bc6a84e3","2157a0ca-18f4-42d8-ab5d-44a320517bf5","301cd040-e006-4441-a747-9364d22c47ef","3d35eeee-6663-4f7e-8168-ef22d081e1d6","06868cdd-13bd-46bf-aa15-38259a882a5b","13780dc2-9781-469b-8bdd-b870f73e73f6","21582977-d6e1-4324-a031-42c708218694","302ec254-e467-40fd-a29b-63935b017baf","3d39d554-2324-4734-bf3f-abfdf1687a4f","06b5d802-09de-4647-b681-d53d63210343","137d20b2-7d26-4855-a8a6-bf470274eed9","21648876-99f2-4790-98f5-2089758e344b","30300a3a-ac95-49a3-be5e-ccbc984a86e9","3d4194f4-f283-43c7-a84a-16586dfb871c","06c33227-fab7-45c3-bc3e-93449eb8b015","13830451-0f9d-41cc-8622-a35a62329d5a","216848c3-c5b8-4043-bb95-09713a33f1b3","3031cb2f-6780-40cc-8b1e-b860e7d669ae","3d523279-e25b-45b5-8f33-3a8bdf92fff3","06c4cddb-fc23-4abf-9a10-51fe5fcbb0e3","139bbf55-03de-4f63-97cb-b3d29911a00c","2171f4cc-6f8d-42cb-a2d2-ab9ab2879f71","3035256e-d06e-4dd3-9d76-5aeb6e470d59","3d635557-c22e-4789-987a-69b356ee024c","06c64aad-10da-4789-9d64-454797986e12","13a8fddb-8da0-48fe-99f8-00bbe4e95757","217c26f5-f5c9-4a2e-bfb0-9ac9702a104b","303b8214-da20-4ae7-b072-44d71c29c0bc","3d6978c8-a432-46e0-8501-7d64e657775b","06cac22f-3a05-497c-ac42-30be3899460c","13b603ea-c557-48d9-b5c0-5344269095ee","219aa5ac-1620-4764-a62b-2a90c70a8583","3040dcc1-ab27-4e57-8ba6-c31c86890f56","3d6fb953-d67f-4f4b-88f1-5f482b7e9fd8","06e16310-9187-4ac8-8f9f-247f4affeaed","13c1d5d1-6da2-4645-ac6e-b68546f38ebd","21aafbef-d420-4416-8145-056d1b3fad0c","304b831c-c11c-4c6b-99e4-9883a6f393ff","3d74a15a-4676-45ae-bcbe-3a63cbd21cf3","06f52fdc-1bbb-4fff-ab72-a94d7480f7c8","13cab336-fe33-4393-94f7-c5392a40e84f","21b241bc-099e-414a-81c2-e8063ee5f62b","305e266b-7a24-4c7e-becf-5e98f61cc808","3d76ea24-1dec-4c25-9997-567805a3ca2a","06fc7834-6a6a-4b1f-a0ee-ae36a449c966","13cb44e2-6749-45ea-a54c-80459e17f2ff","21b40a63-72ce-4a50-9aa5-8f548810a3bf","30610f16-de5d-4e2f-b7aa-868839698e5e","3d8d18d6-5ffb-48c0-9736-a48fd82b367f","070209df-5b0f-4a6b-a644-45a824865f6d","13d5464a-ce30-4cdb-89df-906034d28975","21b7e63e-475e-43eb-9795-261e5f1c9dd5","30643959-241d-42e5-9e1e-f40d8c4d9070","3da25bda-0e47-41c1-bf78-82972fc32579","07040d82-2a72-4ce3-8967-0314704a03c4","13dcb33c-6b51-4dbb-9a13-961de1410707","21c079e8-8c1f-45d2-a502-8dcdcd4fcfe1","30669069-601f-4c24-aa58-cad3a65c0acd","3db1549f-8514-47d1-98e5-9b30c5451915","07074c6d-1eee-42fe-a555-cdce83d67a52","1401735d-c825-4b5f-8631-0c862b6a8886","21ca4834-948a-40da-8a5a-c5eda2296887","306b3ec0-93c3-4323-993c-de9a690e4a55","3db98013-e901-4a45-980b-6587156505ba","070bc482-3f8d-4b91-a9d4-cefc5283c363","14253a26-aad5-420c-ad93-41936fc4283f","21d4bd26-b477-4815-b29d-eef94dcaadc0","306fe63e-1da2-401d-a94c-18852a52c4f7","3dbdaffc-2cb9-4271-a991-55c3a6d5b1f7","070c3625-38e2-4658-9e4b-9dc9a9a69d96","1435cfcb-406f-4f6a-b2fb-9b49f9da0d90","21e30ef5-d582-4a50-bb5a-a1a9e6d915f8","30748df8-5349-4064-b83d-d6efd5dbf104","3dbfe798-1728-4fe2-bba0-a5458e4bfe85","07100dbe-3be2-4200-99a2-4432d564f0f9","144c0477-7199-4bbd-a201-b7b702dfcad5","21f41e88-e084-4d97-96f3-5a5ecab1ce1a","3078d868-4042-498e-b4dc-c47b328bb010","3dc2dee2-1873-4df6-9570-02414fa9881c","07126085-deb5-418a-8beb-ea720b17a488","144f0316-5f29-45a9-8ca2-e693f4cc9bca","21fb7130-fd35-49d8-81e2-77f0f1311fa1","3098fa6e-1f92-484c-af3d-ce45275b2482","3dcaaf81-00c9-4b85-8de3-54d29a626f47","071afede-2591-412e-905a-6063b5fb2f22","149f76a6-cbb3-4738-9dcb-9a951bf9cdd3","22120a64-c451-4f7b-a243-ef841b226187","30aa4223-e0fe-459f-b5e9-b410fd046db3","3ddc9a2e-a434-41b8-8795-47a2bb68402b","0734b60a-1f75-45ae-908d-2f9548afa27b","14a9b8c6-cf87-4ca4-8003-1b6a2afd317d","22175e5c-f2d0-45f5-b2f3-3aab5d33cba7","30b034ce-e213-41b6-b1f6-ea5c93d3c776","3dde4ad0-0c9d-4b6a-950b-2edc519bf5a5","0740c5c1-a74e-4a76-8f33-81c5ceba1639","14ad27c1-f8d3-4c30-b724-9d739df22213","222444bc-b268-41f6-8e4d-b0f5efde315a","30d25659-7a47-4c47-bdf8-e4d2a0bafd8c","3de00934-96d2-4c6e-8bee-bae244dfca8c","074f929c-5f56-40dd-a216-190362498bdb","14bd2868-56ff-4ce6-a15b-de20b2f9aec9","222bbd82-7c31-4a0f-bf54-cdd15e82a233","30e107d7-9b7d-4ac6-8af6-a9e24a8283d7","3de3132f-f2f8-410b-849e-4bc321909388","0758e4a3-5fc3-40fb-b237-d53757a232c4","14c1461e-d773-4604-a8b5-bf7880989092","222df882-ee77-429f-987a-5ee57c25b923","30e96542-fb90-4aec-858f-d00c04229a89","3de5c187-5a27-4233-8913-9cc97c288a0f","07609f25-1620-4578-a21f-519a256af63e","14d4c0e0-32ab-4a5f-9083-fa4b8fdb4ad3","223ea89c-3472-4f23-8cde-0588e37be76f","30fb589a-14f2-4369-9b8f-dbbb9c776bf9","3dea6e55-2fc7-4673-b525-125f6e3e9e4c","076640e2-e796-4c5c-82f9-2ca0ea1c18f1","14d8d8c5-e95d-435a-9b74-b6cd6a8a12e9","2273238d-9741-486e-a28d-a6894c931911","31013bd4-f8ee-4a17-8311-dea66df42f72","3e0fd7f6-b1bc-4e31-8587-83da2709324f","076693f3-5d1f-4be8-b996-82a347564bac","14dd97a1-1a86-43c5-b10a-5e1f63082c94","228736e0-f361-43e9-bfe4-4a32d83b3037","310395c0-5b83-4c14-a8dc-cdb86d89f0c5","3e18571f-b0e9-4903-a911-8c031fc6c609","076afcbd-e529-4efe-b3bb-bf8d95ff10de","14de8c18-733d-41db-9302-8229859f6ea9","22960a5c-6923-496e-9174-e27a9a72e189","311a095a-e00d-4b0d-884b-95857f933dad","3e1a9c67-6369-4bd0-a8fb-84e631cc41ed","077a6700-97f1-497a-89c4-2ff9efe680c6","14e2179b-a83f-4485-9312-b196feb48207","22b69761-6d27-4602-9377-e500ca4d8214","311afe1c-27ec-42d2-992d-3128cddd795b","3e2c48e3-638b-4ab5-8bba-0fa671c468a1","07816b89-2a3c-4f94-bac5-4fc950881a78","14ebd103-b246-4009-8470-bfdbffd54873","22bc89a8-a7f5-410f-867d-ccbf93babc5e","312a7a59-ff67-41ef-9c1c-be4dbf49dadb","3e2d0ed9-0b51-49c7-aeeb-a2efab68830f","07832192-ddb0-4033-9ec2-c4c5ef0b700a","14f92121-9f43-4d4a-8798-cadc2c4f7d74","22dbc5a9-9e4c-4a6c-8f42-d9e0357b55b6","313969dc-db53-454c-a38e-4659882193af","3e2e2d00-f0dc-45f9-aa01-f6a61d34f7f6","07963123-8a79-4a0f-a19c-67f44c4d2566","15065187-6202-4003-8b6f-31bcfc533cb0","22e7ae5f-e20a-43ae-8421-c791999e688a","315a8ab5-1d43-45f1-aeae-333c73f44639","3e3c94bb-ca6d-479a-9ca1-1a985183eefd","07a1936f-6569-4dec-afb6-c224c321f020","15104547-176e-4fb4-9067-5f9c0c50d403","22f46a93-7119-443b-97c7-29b061b38537","316044c3-6dd1-496a-a64f-618b192c2208","3e4b9a23-2625-4176-a76c-c4a242c2ac06","07a25a77-cf76-4c21-9c17-36d400f246f5","1525f040-df8c-433c-b470-02eec5b956cf","22f87751-5688-4223-bd3b-16cc1513c2e5","3187bf2a-a35e-4864-9713-8d2f0371dca6","3e5e6e65-9d98-4952-b8be-7682b8740157","07b42515-649e-489e-a4b7-f2762bae6570","152cf7dc-cda8-4cae-882e-c61889dc205b","230abb61-4c57-400f-a8b4-c071f5399707","31884cb2-64d8-4db3-beed-3e461734fdb5","3e768e10-066b-436a-aef8-03d477705bff","07c3b131-e164-4f26-901c-16b45a8ea6ff","15348a70-07f4-4c80-a110-a5b00fe6e939","231a663c-09d5-4a1a-a3e4-ae0975aed2c6","3190e85d-5f9c-48d8-9c9a-5226e1f3a6eb","3e817ce9-e9bf-4838-94fe-11bded83801b","07c54d92-1116-4112-8d43-c7c059efed0f","1549dc33-b7a9-437b-816c-322ba2fec11c","231fd8b6-9c53-448a-9459-b503ac669331","31949e9c-f081-4f18-9f24-f404da4aa769","3e86bdd2-3a5e-46cf-8077-d5f3b4bb7493","07c9f1fd-7d5b-4ad2-a304-431069545474","157a89e2-99a9-4eee-b30d-d15c2b2b4337","232b19b5-b864-4b17-9d0f-6b9ae2ea1077","319729af-1a0d-44d3-8224-2a52eac29aa5","3eb34e2f-8e67-4e79-b4af-20f71b0cf04c","07d8c7a7-3353-41a7-9229-d0987818ac6f","1583b85a-3366-4882-bb02-d1be9692e9bb","232bf3de-603f-4d0f-957b-2e752b5fd294","319dd42f-d38f-45bc-8c7c-62f0627b1fe4","3ec0f9c4-7d9a-4098-842a-9747c024f163","07f35095-1e67-4775-b1a0-a80417f495c3","158bdce7-2ea3-45f2-96cf-289ff843dc80","234d1b99-eb0c-461f-b090-175a22709222","31a641b4-2910-4163-8147-873bb3af97e6","3ee57e1b-4bed-4f04-8c86-aef4903f4df5","081205ef-9057-4974-9110-e17165a0a1ed","15b0673c-cb2e-4da6-b227-9e48b4dc3d37","2368f1c4-5cb1-494a-91fe-3b4258e1cef7","31a6de3e-0c0b-4317-b974-1582f8abb86a","3f197c0d-176e-48f8-a5e8-abec572a3866","0838723a-bb86-459e-8f96-82d42ade03a0","15b0aeb4-c5b7-4c99-83f6-3a25a641088a","2371f2fa-7adc-4eae-abe9-43afb912581b","31a8fe71-2982-4249-a408-9ffd5d893009","3f2644e9-08f7-45b2-b5fe-44a5c52ba93c","083bbcaf-2d5d-4a4a-bc0c-53ff59606996","15b1be01-527b-435d-9f9a-6ce1851172d4","2373753f-920e-406f-967e-06465392dbc8","31abb030-38ec-4c05-a762-ed3b627d1313","3f2a6f90-39f5-4c1a-a362-03b5ecc0c84d","0869eca7-c95f-42a7-9899-998e501aed39","15b6b3e8-999b-4788-9534-4f4ae5f5280d","2388b46a-3412-4461-bbc2-d009bfdbd550","31bb383b-d207-4e7f-977b-4b29fa1e06af","3f393a07-5e85-4770-b4bc-bfa21e8db61e","0875c81b-c93c-4e59-9a51-b76e764ef8a2","15bd2a9f-580c-4ad7-94c2-a9a54455959e","238a873c-9299-4769-8faf-d0731154f1a8","31c35f1f-f663-4f8e-aa17-bdd77122a572","3f3b4cbf-3037-49b7-bbf6-4d8c212e1672","08816cc2-7d63-4495-bea4-50f7a54ec4c7","15d06c48-82ea-49ca-817c-abbe6266623f","239e8b83-cee6-48c9-8ed9-27445f8bfa27","31c5490d-26d2-48b4-9a67-d32d233a6823","3f3b7d70-271c-4aec-9b49-53d2d35f3f21","08844e58-4dfd-4957-acaa-37d4fb76b207","15d09366-7a79-42b1-a6e4-573e5753a76e","239f1bf9-c8d8-46aa-9ecb-bdbbff7dd6cf","31cb2fde-7b55-48d8-a529-89b04a3a65bd","3f3e6343-a99c-4290-9ea5-5d6ecfe5288d","0889bf6b-e041-42df-8ed6-e9c535bffab6","15d69cf0-1c16-4dc7-8453-d2c067e020d3","23a060f4-4369-4b00-a63d-f479598f6089","31d9e5ad-01a4-45a2-9067-ad7726da8b08","3f4485c7-480d-4370-b040-ad0ee12d29d9","08915a60-6253-4e09-ac3a-bff678c2d335","15e3afa8-d6a1-4293-9240-62aeb2339a0d","23aab36d-8e1f-4038-852b-2acd267c77a0","31e12c51-d7a9-4e12-af67-d50f99eb5569","3f63811e-2d8c-4560-8581-2efa209dfd5d","08973e37-3e14-4a74-a9a0-e55786ad07e5","15e415ff-1ce2-4270-ae9b-53763c324419","23b23874-df0f-4945-a0b6-31c62cac3be2","31ec596c-9ccc-4f02-900f-a74893fdd35e","3f640838-b14b-4d3e-9357-a1f7ba01df2f","089ee077-07ff-4c93-bba9-886fa6d52dee","15eddc99-dcce-46b3-b43d-16c780a9abe3","23b6ec5c-37b5-43b5-aaef-7c35b3872085","31f529ac-4526-4186-92c1-c81742a4bc52","3f6b08a3-d60b-4019-816a-2196abcd1dca","08bb4b22-3c49-43dd-be82-a475a98bb9b1","15f589f0-b629-4d33-b5d2-ed30ba9cf83e","23cb453a-dbc6-4d3a-a65b-3d7757b6727d","31f8f641-cd5b-40b3-9d88-f45726373433","3f79ebac-a0ce-4f97-832f-93957ca3b2bc","08c6d312-6c2f-4d48-8493-3b9700eead01","15f74045-447b-4a4f-8813-caab85627d04","23f0f635-a144-4050-b39a-c041523a1077","3202c430-8b89-4fa8-8c17-97f63ca13f80","3f7a6656-e468-4cef-8dc3-7dd27bbd6ab5","08e6b041-c84b-4e5b-9949-76aede300c92","15fd96c0-8ff8-4d74-a38e-31fa55b55c1d","240254de-13aa-4757-8a11-e6260341912d","32042077-e256-4bec-a888-17a10984de79","3fa01371-803a-492f-8048-247e4d694631","08ed2f64-5576-4ffe-8192-12068a4d7d82","16085f79-9abe-443c-92fc-39f89c0850af","24032b67-0c45-4947-a705-6ea82418c582","321a5508-af13-4bdb-bd83-0f8709e09a80","3fac3963-c6e7-4e5a-ace9-7570b6438b81","0934c5c7-770e-4c4a-b0fa-37c227e28912","160dd247-cd0d-44aa-8935-d0fd1702bf1b","2411c51a-4049-476f-84ec-21b28bfe3899","3232a46b-4715-40f1-9ce2-10d80a5e3dd6","3fbaa1d6-eeb1-4078-b117-5bf30f4c4d6c","09622dba-7931-4dec-a8d8-de4534f478fe","162e3519-3e22-44c9-b7f8-0f7c17960998","2414b753-bb6b-4298-8bcc-8b4bef179778","3236994a-f628-45ad-8ab6-ca35c22c74b2","3fbe1204-b35f-4aa3-b79a-a32af068936a","0962daa4-71ed-4a35-a589-4f56822acbd4","163555e9-c3c6-4f28-a543-eaefd9ea19af","241c5da7-a1b6-4dad-bbe4-c3ee26f1eff2","32455225-a6b3-4bb3-97b1-47765e8284e2","3fc09d41-5a0d-4956-8865-2594da9aa054","096cb261-2a14-4eb2-9f23-b9e63e7f3cba","1638d24e-17c8-4d0d-b396-3260482861f2","24230b86-98ae-418d-b8e7-3c20d794a06e","32520ae5-917b-4811-8b39-3d9d62eb9482","3fc48400-94c6-4bea-b1e5-63efa3e6bdc8","09715192-63fa-44fe-b799-9c77d5c57428","163ab76c-7374-4116-baf1-5a57ac6f2187","242b615e-9f98-40fd-b371-e7025aa5307a","325c5dba-b1cc-4851-9fbb-e00a48f49583","3fc9deff-0484-4d6a-b094-fd1ac71fa310","0975fd56-0cab-4345-974b-59a6a43c4c13","1641ca3e-70c5-4727-8559-56c0a237011a","242c80a5-1dc5-492e-bd79-caf5a3ea5ee0","325cdd2e-d485-47f1-ab2b-f4d6e578eea8","3fcdab38-19bd-421d-81cd-f285000a53a2","09794db8-d330-4185-ba0a-32af7d048bf5","16507d14-b26e-4561-833c-b960f533b6f3","244160fe-ebf3-4de2-bffb-16a24a694449","3265952d-2979-4042-9df1-25c02e806240","3fdc357f-8dfd-4d20-8881-894470803085","097d0e8f-b679-4ff2-b0d3-035176d52afb","16565175-7f65-4b26-933e-5f568ea53458","2459dc19-98c2-4824-8751-68aa72493998","3269caa8-b49b-450e-ab2f-9e6d8d60db55","3fe6935e-fe35-4c0a-85a2-c1f148273be5","0987cd1c-40a6-4f26-8b70-2b15ea558143","165d96d4-2c34-41fd-9d30-8cc86683f929","2461e298-4378-4f3d-b670-0e5c349a47ca","3275f6a1-2809-4f12-8b60-b35644531c77","40279c88-208e-4c47-93b2-3ac7b4393729","098d75b1-5d01-46be-b6ab-29f10070e2e6","1661ca87-b4f9-4f5e-a9f7-8868783f0d25","246f8295-50b3-4729-81c1-62b02ff74a19","328784d8-2aa5-451e-b94e-9f534e7fd0c5","403a2167-15bc-4d48-8472-ff29de27c97c","09b682e6-c6d4-4f69-b4ca-4079a55efe55","1678e21e-834e-4a82-bc77-83d3a0ddd038","2478a923-da6a-4037-8707-31290ddc9913","328a7543-fe1f-4dd2-b7e6-d65c8e84eb9e","403bc26a-adcc-4ac8-aa2f-9e103b632474","09bb867c-4bcb-44dd-bee4-02976ec0c17f","1681cea2-9dfb-4355-b24b-f60cc0c7e3a3","248479d3-6fb7-451b-bb6a-ad2388fe63f0","32d3f203-9d82-4c49-aff7-b708dc95d4fa","40416ee5-9f61-4820-a405-8b4f84c0f7d5","09e7a023-75e4-4bb4-a5ff-eb6a74d0536c","16c67e48-7dbc-4a9d-9ff6-21cd81d2318c","249267d2-1e2a-4893-aa33-af6b6b67f3f7","32d8acd6-51e7-406f-957d-049fe702ba46","4054f8c0-088b-48d7-bda4-48a76ecbf918","09f48979-3bde-4be6-9dde-52b18eea0cc1","16d95713-3dbd-48bc-b878-21c68e7f5b3d","24929236-1344-47f6-88c9-34dd26be930d","32e3bdce-7d8c-436e-a6c2-ec01a8699329","405cc3be-df1b-4f72-9fad-aeeb5e704daa","09f4a382-6a0b-4003-a623-18f6336f7aa9","16d9f8fd-dbde-4687-9086-efd5636ca1f3","24ba1410-5497-48ac-903f-17652c6df6c7","32eca4d3-1632-441d-8bc8-3138bc644f41","405f4430-a80b-4707-b3c6-8cb09786314e","0a0a2c98-c9ee-4b96-917c-1dfc08f63fd4","16e63c9e-5c1f-4f43-82e7-56533541c313","24e40ddd-0287-4eb5-80e5-b23af242610c","32ee002c-9660-44b8-bbf7-b29c4f131652","407427fd-16d8-4f2d-a998-a904276218b8","0a148b60-bf32-44f4-84b7-e793882a337f","16f5147b-a067-46ab-bf1a-245f93ddbd21","24f59d4a-726f-4434-99ec-877546ae935f","32ee5634-97b1-4a33-9a13-8725575d5e7a","407782cf-600f-4972-8bdb-6ce13aef48b6","0a152514-3e95-4a85-884f-49e75189eb48","17010cd0-586b-499e-8c58-63eabf62b2ef","2508529e-41f3-41a3-9638-1f81789980af","32f532b3-3043-4337-a49a-7b64ddeee983","408869bb-bbfe-4969-86f9-28b42828c153","0a18b2fc-f984-4e76-9e84-eeac8b5bafa3","1705fe91-591a-4592-8049-fdf3a8c257b9","25086963-38c8-43a1-b228-9373a6a873b1","330b4ab5-1fd6-47c1-ab4d-857b7191f142","4094cc2a-cb86-4a8f-94ec-21d3ddd3417a","0a1e4b9f-e56f-4f50-a25b-3434ae203a93","17147b98-b08a-4f72-ba47-aa127f168765","2508ffb0-58b7-45d1-909f-67517a7f6db0","331108bd-1c9c-4e57-b09f-949332ead722","40a55d72-64b2-45ef-8453-e05adb6a1478","0a2b2a43-bc4a-4082-bd5f-755fceea0140","17156823-09db-4acd-bc32-2ab0f8e4c303","2520ab1d-641b-401f-9d17-488219402149","3317f992-76b6-464c-b78a-b0c883f1c7ee","40d41d2c-c3a6-4e15-a77f-6a9544df6055","0a48fca5-5dac-4eb7-bb1d-f46907297439","171a06ba-6f5e-417c-91d9-1aecda773f49","2550bbdf-6c05-44b6-b465-c24766b85330","3318a308-04b5-4284-8047-beae97aadbce","40ddb78a-7619-4bb2-b022-d35b771ea839","0a516a2e-7949-4628-a78f-d56f3b1a679d","172b7704-6501-459f-a07c-3a774582d119","255ca44a-3e64-420f-8609-5dd983f6b19c","331ed2cc-2b71-4282-bdb7-be8cdad3323d","40eddf80-1320-4d99-baf6-3acab28dc9f9","0a5db4b9-edd0-42b0-8aba-5a71c5cc8c7a","1733e920-b0b5-4765-acb5-ec82e839b4d1","255f0e51-32ee-4322-91cc-2f66b525b5af","332d3172-07a5-4eaf-9895-074f02c8598f","40f574d2-47ac-410a-82b4-cd288e88ff78","0a7b2b71-af1c-4bab-83ce-18d6016a68f0","17620aba-d5bc-44dc-8b67-38996a4d8fed","25903662-a4b9-414e-a5c1-50816c8f630b","33441981-1f45-4f17-b217-23b6c08c9823","410ef379-ced2-4a07-98d3-d6fcfa606b8c","0a7fa417-6af7-47a6-8b06-4f2561cd96c2","1766ccce-a1b6-4139-9118-b44055309dd3","2592cba7-8349-4f70-af20-144d96d80b94","335ca924-47e7-463f-9b81-49352b329ce8","412648ce-9c8c-4263-a730-be11b08d0933","0a8b2096-8b9c-4538-880f-797ec448a99e","1768b477-4c79-4df1-a347-a57e424022f3","25a57876-3f8d-437b-82af-f6526a020906","337ab318-ba91-4185-8231-0035c3753d5a","413393a7-d5cb-4f88-b6f2-c206a003d9d6","0a957b0c-caed-422d-b880-34caf7d90d16","176a5ca1-533a-4191-af81-0cfa63a4e6cf","25ad1373-b0e8-4056-8a8b-8542d041a94e","337c43a9-5481-47d0-b47b-aa819c08b366","4139ae8e-1a41-4a20-b814-806730ce3202","0a9a846d-03a4-4529-8378-89438405bfe0","176cc67f-4bbc-47eb-8366-ec74d10d4a4b","25b92acb-f152-4a6a-845a-06ec7fd947d0","337c8dfb-0ca6-4b61-8c8d-ce01c51d2c2b","414d6039-8137-4e0f-ae0c-a7136d1c39e2","0a9ba5f4-742f-45a4-8e57-363d26951e39","176ee8f2-5d2d-46cd-bdb2-8fc8d380194a","25ba1d77-25b1-4a57-a141-4e52699131e9","33822517-7ead-4623-9035-c10ce6034f3f","415fe314-975d-4913-8b8c-a3f0fce92a34","0acd1959-f0e6-4623-b1e1-0bd859c8038f","178ae749-9d48-4acd-9404-3232598730af","25cd70c4-57be-4f50-9a9d-7239b4589eeb","338f3a38-278e-4893-99a0-3aaa65f1af0f","4164183d-d1c4-43b5-aa81-6efc4a4e0228","0ad864a8-663e-4a9f-9de2-8fd1f6d06664","179cc162-8c7f-40b1-84f6-0ac4e34f2ee8","25d41bb2-46c0-4ee2-bf0a-34198ee0d7d5","339141b8-f797-4dc9-90c5-ed34b5a461cf","417c12bb-188a-4ff7-9003-87a707ff1410","0adff436-a049-4978-a135-a3ed4207d6f0","179f14d5-d994-4493-b683-032101426d89","25db20c7-5b23-4042-b1bf-491621808b76","33965cb1-464f-4bd4-8d00-619f982b1efd","418f11ab-7120-4d63-87f6-aeb17501931c","0af205b9-1efd-4b00-97c2-623d0327c6a9","17c5a459-21b4-4c5c-b6eb-5f6712a4addd","25f6e519-c10d-4911-a54b-7481f4cc5d6c","33d9b9d7-44c3-4775-9235-186252a00a3c","4191262b-b925-4656-aaab-d76ccaddc264","0af9506a-0a33-44db-ba63-5aca5b209845","17d7e908-6d4e-4260-a4a4-69aeda721e13","25f9adc8-d309-423c-8903-f56489f501a0","33e2e04c-fe1b-4e70-a3ae-dd9a67529bca","4192a5ab-333e-403b-991c-90682d9d560b","0af9d449-890b-4930-9445-0fca5c0f0b87","17ee2ea3-c719-403f-a854-3856d47071d0","260a3e02-7a36-40be-9a25-c515db10f99a","33ee1557-bd6f-45e9-aae5-4f2a3ecdca96","419f472c-bb27-45f5-ae67-ecae40518afd","0afe46b0-6236-4b97-b350-4bb0d653ebdb","182b5a50-0f4c-489e-a5b7-60d8cca0bbbc","26151ff9-cfd1-4680-a044-a0ac86fea299","33f05171-5785-4efc-beb8-a5738ca887c7","41a8a582-572c-4440-b542-31ae0e6dcb70","0b216b96-0930-4c3b-a619-47e6121a4530","18362758-8648-4443-8b52-33d5f7885b42","2616d0bd-3f6e-4865-b509-b7647a72fbcf","33ffe37c-1006-48d2-b4ab-a1319ef13451","41af7c4f-fba9-465f-9771-6cedbefb3a00","0b223cbf-4671-427e-89fa-7580632a240c","18380a8a-ca03-4291-bb76-5d3df15fe972","26345b4f-584a-470e-afb4-ccc67b63992a","34091b25-b848-43c4-9402-af448377c829","41bd8998-18ab-46f2-957d-804b955c48bb","0b30a630-da7e-45e7-a91f-bf0ca2652dab","18881cd8-d80b-44f6-b969-d80de97083e1","26385366-c5b6-4ad6-86db-6557483d321f","341bdc09-e3c1-4489-80f2-abd3c05460a2","41c44471-114a-4565-9dfb-5ecf7d55e3b3","0b348370-856d-4e27-b68e-315599f549b5","1889a4df-f04c-4b05-b1b0-61e7424b0f56","2639fc1f-bc16-4d98-b45a-b4262994dfc5","3425d81b-d14b-4f82-a8fa-1269a252faf2","41ca4c9e-8913-4884-966c-97f3c2c4f0c8","0b41e3a0-c82b-4343-a8af-80a932511c9d","18927990-8b4a-4542-bcfc-e282a0040d1e","2649525d-d39f-4bd0-84c9-ad7b635e1b88","342eba64-3ba3-4442-8e98-be4cd40b012a","41d01259-0223-43da-b18c-d43f4ea29c16","0b4a22ff-8d7f-40f3-a7f9-dcd0a157b09f","18975416-893b-4f2e-a0fe-4e1e0c1c4d9f","264a69f1-0f5b-4a02-92da-c6e786d7bcb2","34378fa2-fd64-47c3-a98c-0604889ac985","41d2cad4-9e27-4e29-9a0d-4aed115a4fbf","0b5147cb-06a8-44c2-aabb-90ad92431243","189dcaf6-d352-4291-a650-967d0b41584b","264f2436-0b1a-4385-af59-d2de7337ea26","343836cf-f6cc-48f2-80c9-694438eff0fa","41d3c995-4c53-4900-83e6-bfb0aadce5ba","0b5b64cc-b2cf-4293-ac62-0779bad5dbe2","18a68719-1c85-41a3-9c80-bba5e838f27a","26514cb0-4c55-4698-92d1-47348bea1deb","34439e18-e9d7-410b-9dc6-cf2cc2c04a49","41e4fb16-f4d5-4bbc-95b2-b905804c3871","0b623847-4507-433d-90b8-8d0c4b210015","18d5424c-c5c4-4592-9041-212bf6cffe92","26661441-c3ca-40cc-abaa-c589c16be852","349043cf-ccc0-4cab-a1d9-a8a1ae33c2db","41ef31cb-af05-4543-995e-dcaef98f593a","0b6771dc-3273-47c1-a214-1508aa4d0dae","18da7bad-3064-4b92-be30-29a6cea77187","266fc90d-34b8-46b1-a32d-ee6df00e28e3","34a8f6e5-702e-4348-8177-53635dde558e","41f08a47-30b5-4220-913c-f5f592020568","0b875b95-83cf-4dca-853e-70767041885f","18df51de-b886-42e2-82b4-7b9a3c639b63","26709593-e89a-42ee-a8c4-1c46136a7dff","34ba9615-7d35-4ce3-8b47-deb3fd4ba266","42019046-1e5f-481e-bdcd-67caed7821d4","0b8a0bf1-ade9-4635-aa99-8ccfe8ab2b38","18eecd88-a836-478f-b114-d3cbefe9679e","268640bc-3990-4002-8d45-70ef850cd068","34c3dc8a-b0f4-43f0-9cbf-ca34435452f2","42078443-0434-44ea-b9a4-943f82f13866","0b959e5e-4739-4b75-b5f2-b67078d4a577","18f51785-53f8-451c-8717-6e86068e75f8","268f0335-72a0-43b7-aa32-e8fe7d3c1822","34c8a622-9803-4425-8be8-b119bdf7d725","421e3d17-a384-4dfd-86b0-6f0d8dad076e","0b963df0-087e-4555-8be0-c971835a8fad","18f7faf7-a769-4fee-85e7-bed5d884b4db","269cf4e0-c1de-40de-ba1b-726c01066ed1","34dcb2bb-6ca0-4f8e-816f-621cce7aedee","4226e037-4de3-4b7c-ac6f-aac64201476d","0b9b2c6c-5373-47f6-af4a-423ba1fd4c9b","18fb4159-53af-4aa2-89e8-3a2815117228","26c4001b-d2d1-463e-a787-fc6b1075d817","34e6be65-da87-48dc-b866-fd8bf3243f36","422fcb92-101f-47ab-bd6c-d2be0ef89642","0b9f7b87-2e59-4184-a174-4b3dc9ab8848","192861b5-8c16-485f-ae93-8fe2e6b2fb57","26c62920-d95a-4c5b-b07b-a707a613ff9a","34f66a26-c5d8-418b-9e70-2604d8971630","425160cf-5fbd-4853-bc7a-83435d583b85","0ba215f0-f5b9-4652-a5c3-72671e3828d8","19477a14-9ca4-4632-971d-0913dc494e3f","26c63979-5ed2-4785-941b-2a38632b6e33","3504d595-e12c-4c61-89a8-4bf77abf9eb0","42517e08-90c4-4ae4-826f-1314f40f949c","0babc2c3-a72a-42d3-ae9d-7c686076e837","194b06bd-6483-41fc-a278-171df5b9f5a6","26ccfe10-859e-4478-8069-9ba36d22bc73","3508e6c5-af23-4327-bbfe-7143a15f6934","4267d307-2331-46ab-820d-c0cf4ebac2c1","0bafc19f-a81b-4891-b1b5-53c0c5bb6bdd","1970b431-41dd-41fb-9b70-53348e60ab6b","26d1dda4-d87c-4bd4-8b79-5d91625b9e8e","351d9001-924b-4a38-bbe2-79f01745b537","427208e3-47eb-4a57-a94c-c62abc95d670","0bc8c244-0586-4274-acf6-19f53461ded1","1982f000-f014-4bd2-992e-5a41bfee2236","26d7bc68-216f-430f-940b-31a8e0108af0","352033c8-f42c-48fd-96f0-f20bb45c8499","427ce82a-cf62-42cf-a826-7397baf825d0","0bc8d565-5beb-4ab4-a405-6827c8b7e454","198be071-6aa1-4e12-a3b7-e9dc3c15831d","26e22f26-0d34-4a31-a435-cf73641f1eee","35243f60-66e2-45a6-ae28-4bb5cba7827e","428a047c-dc0d-4cad-a0e3-e07bf63ecb15","0bd4779d-1149-4a47-8b50-592a39e48176","199272c1-c87e-4dcd-b645-b7cf489189d8","26e32491-3ae5-4af4-9ab5-87d24f054afa","352ebe12-78ff-4d24-aa27-687b5d6a0801","4292f901-14b9-4ee1-93de-4a632128a255","0bdd6c43-01bc-4ff9-95d9-5311c871a6fe","19a5f4c6-a308-4fe4-b493-56c9a5dade64","26f3f412-a85f-4e5e-8589-fdd25dda6a29","353324fc-76ef-4d5a-82ca-98296d0b6f14","42a057a8-dffb-41d7-a838-dff32ecd9bae","0bef3165-e232-44c2-aba8-1532ca199806","19ae19ba-33a2-4100-b668-207c2f4797ab","26f49448-fcf4-447a-8836-549bc586dc61","353a3fc8-5e45-441a-abc3-91410bf803f3","42a621f3-a727-42aa-9bfc-39d1b426880d","0bef3c14-a45e-4c7e-9ed8-cfab09738826","19ccd0b7-4af7-4265-8305-02bf16e12d11","26f8dc9c-60c5-4f55-b606-1bebf4612312","35577d1f-c178-4919-a636-888376fd6e75","42c2f5cc-91d9-45e6-89bc-23e7db360e74","0c0bda36-bf44-4494-9803-445f41a21f15","19e633ea-4608-4d65-a04e-86d2b00029ed","272c02f6-31cc-424b-ad41-98d4c2aa63ab","357ebb0a-52a2-452b-a730-2db4d2a674ec","42c3294c-ed37-47d5-9385-2afdab465f84","0c142bfc-8480-4bb2-bb3c-8ac0ac7883fb","19e64c7b-a090-4c6c-8baf-b39b9ea4e2db","27336fc3-feef-4464-b556-8bb8327bfc6d","358307b6-718a-4f7b-ad8d-11618d0bae3e","42c383d0-562a-4b27-b32c-2dd3cdb3a647","0c1f6691-11c2-406f-b3de-05dde5219349","19e990c0-e45f-47ad-bbbd-2fa62134c295","27340a11-b5c8-4bfa-b135-f618eb439604","3584f42f-c637-4790-9fc4-e5f8ce147fd6","42c42a0b-8c4e-45d9-b25f-14934791b0d2","0c20ac7c-7549-405e-88fb-6911914b3592","19f0c15a-0c6b-4630-b7e9-5b45e0c77aa9","275640b3-dd12-45ed-b0b3-674aa8fc84c1","358cf3a0-0c8e-4fc1-b044-1caf15743182","42d547ef-1229-428b-92b3-ddd09a39c319","0c217bc1-0379-42c4-ab61-8d4321518d41","19f254cc-564a-4741-bc4f-de19b880b12f","27593aa0-a98a-4f4a-aafe-c21765b5ab1f","3596021e-9c34-414e-8e06-2e8baaccbc21","42d58ec0-78ba-4f40-b2f5-6c0cfe657650","0c29deb7-49e7-4d0c-9135-11d3e1ff92b0","1a0a7c9e-36a9-432d-8714-330e0bc8d1b3","2761aba2-421d-426e-9c03-5f475e0fe99e","359d827b-ad4e-40ac-9435-6977ded47828","0c311e78-1153-4a7e-a418-d809254a311a","1a15c8b1-51cb-4721-87bd-f42849a2c4ab","2766925d-5713-4c84-afd9-1040fc9fedf6","35b4b416-4eaf-44e6-b974-5cdc07ceb6cd","0c3909ec-ff0c-473d-a424-8ad91de16849","1a19da3e-6b4a-4b0c-8ad2-a57caa0a301a","276b2326-c4db-4235-b5b8-970ff67ae2c1","35c2237e-174f-4254-9003-7a197c74e24c","0c3deeac-75eb-48cf-b116-852284034367","1a2ef12e-f8c1-4d4f-8116-8d4dd4c5a413","276cc75e-ab6a-492f-aede-a277967c6d4b","35db9e15-2d6d-4192-8db8-2198a68c72d7",],
        availableXMLs: []
      }
    },
    mounted() {
      this.reloadData()
    },
    created() {
      window.addEventListener('keydown', (e) => {
        if (this.footnoteData && (!e.srcElement || !e.srcElement.classList || !e.srcElement.classList.contains('no-arrows'))){
          if (e.key == 'ArrowLeft') {
            this.footnoteIndex--
            if (this.footnoteIndex < 0) {
              this.footnoteIndex = 0
            }
          }
          else if (e.key == 'ArrowRight') {
            this.footnoteIndex++
            if (this.footnoteIndex > (this.footnoteData.allowedIndices.legal_indices.length - 1)) {
              this.footnoteIndex = this.footnoteData.allowedIndices.legal_indices.length - 1
            }
          }
        }
        else if (this.splitElementData){
          if (e.key == 'ArrowLeft') {
            this.splitElementIndex--
            if (this.splitElementIndex < 0) {
              this.splitElementIndex = 0
            }
          }
          else if (e.key == 'ArrowRight') {
            this.splitElementIndex++
            if (this.splitElementIndex > (this.splitElementData.allowedIndices.legal_indices.length - 1)) {
              this.splitElementIndex = this.splitElementData.allowedIndices.legal_indices.length - 1
            }
          }
        }
      });
    },
    computed: {
      ...mapState({
        document: state => state.document.document,
        tokens: state => state.token.tokens,
      }),
      // render_images() {
      //   if (this.document.media.length) {
      //     return this.document.media.map(medium => { return require('/public/images/scans_docs/' + medium.file_path) })
      //   }
      // }
      checkPDFAvailable() {
        return !this.availablePDFs.includes(this.documentId)
      },
      checkXmlAvailable() {
        return !this.availableXMLs.includes(this.documentId)
      },
    },
    methods: {
      downloadXML: function () {
        this.$store.dispatch('getXML', this.documentId).then(data => {
          let filename = `${this.document.edition.sigleLegam}.xml`;
          let pom = document.createElement('a');
          let bb = new Blob([data], {type: 'application/xml'});
          pom.setAttribute('href', window.URL.createObjectURL(bb));
          pom.setAttribute('download', filename);
          pom.dataset.downloadurl = ['application/xml', pom.download, pom.href].join(':');
          pom.draggable = true;
          pom.classList.add('dragout');
          pom.click();
        })
      },
      downloadPDF: function () {

        // if (!myfile.exists) {
        //     alert(myfile + " could not be found!");
        // }

        let filename = `${this.document.edition.sigleLegam}.pdf`;
        let pom = document.createElement('a');
        // pom.setAttribute('href', `/data/document/${this.documentId.slice(0, 2)}/${this.documentId}.pdf`);
        pom.setAttribute('href', `/data/document/${this.documentId}.pdf`);
        pom.setAttribute('download', filename);
        pom.dataset.downloadurl = ['application/pdf', pom.download, pom.href].join(':');
        pom.draggable = true;
        pom.classList.add('dragout');
        pom.click();
      },
      computeContent: function() {
        let content = ''
        if (this.document) {
          content = this.document.content

          if (this.documentTokens.length){
            let shift = 0
            let openedElements = {}
            this.tokenLemmas = {}
            this.footnotesFue = []
            this.footnotesFul = []
            this.document.structElemenentsId = {}
            for (let index of Object.keys(this.document.structuringelement)){
              for (let obj of this.document.structuringelement[index]){
                if (!(obj.structuringelement.label in this.document.structElemenentsId)){
                  this.document.structElemenentsId[obj.structuringelement.label] = []
                }
                this.document.structElemenentsId[obj.structuringelement.label].push(obj.id)
              }
            }

            let countDiv = 0
            let countZw = 1
            let countPar = 1
            // Clear all closing elements
            for (let idx of Object.keys(this.document.structuringelement)) {
              this.document.structuringelement[idx] = this.document.structuringelement[idx].filter(
                structElem => !structElem._close
              )
            }
            let structElementsIndicies = Object.keys(this.document.structuringelement).map(index => parseInt(index, 10))
            for(let token of this.documentTokens){
              let afterTokenText = ''
              let tokenText = content.substring(token.idx + shift, token.idx + token.length + shift)
              while (structElementsIndicies.length && structElementsIndicies[0] <= (token.idx + token.length)){
                let foundElementIdx = structElementsIndicies.shift()
                for (let documentStructelement of this.document.structuringelement[foundElementIdx]) {
                  let addContent = ''
                  if (documentStructelement._close == true) {
                    addContent = `</${documentStructelement.structuringelement.label}>`
                  }
                  else if (documentStructelement.structuringelement.isSelfClosing == false){
                    if (["fue", "ful", "fol"].includes(documentStructelement.structuringelement.label)) {
                      if (documentStructelement.structuringelement.label == 'fol') {
                        // addContent = `<fol n="${documentStructelement.content}"/>`
                        afterTokenText += `<fol n="${documentStructelement.content}"/>`
                      }
                      else if (documentStructelement.structuringelement.label == 'fue') {
                        this.footnotesFue.push(documentStructelement)
                        // addContent = `<sup data-id="${documentStructelement.id}">[${Utils.letterNumeration(this.footnotesFue.length)}]</sup> `
                        afterTokenText += `<sup data-id="${documentStructelement.id}">[${Utils.letterNumeration(this.footnotesFue.length)}]</sup> `
                      }
                      else if (documentStructelement.structuringelement.label == 'ful') {
                        this.footnotesFul.push(documentStructelement)
                        // addContent = `<sup data-id="${documentStructelement.id}">[${this.footnotesFul.length}]</sup> `
                        afterTokenText += `<sup data-id="${documentStructelement.id}">[${this.footnotesFul.length}]</sup> `
                      }
                    }
                    else {
                      if (documentStructelement.length) {
                        addContent = `<${documentStructelement.structuringelement.label} data-id="${documentStructelement.id}">`
                        let closeIdx = documentStructelement.length + token.idx + shift
                        if (!(closeIdx in this.document.structuringelement)) {
                          this.document.structuringelement[closeIdx] = []
                        }
                        this.document.structuringelement[closeIdx].push({
                          '_close': true,
                          'structuringelement': {
                            'label': documentStructelement.structuringelement.label
                          }
                        })
                        this.document.structuringelement[closeIdx].sort((a, b) => {
                          let idxA = this.document.structuringelementSortOrder.indexOf(a)
                          let idxB = this.document.structuringelementSortOrder.indexOf(b)
                          return idxA - idxB
                        })
                      }
                      else {
                        // We need to add numbering and class to div elements
                        let elemHtml = ''
                        if ((this.editMode == true && this.editViewType == 'div') ||
                            (this.editMode == false && this.viewType == 'critic') ||
                            (this.editMode == false && this.viewType == 'interpretative')
                        ){
                          if (documentStructelement.structuringelement.label == "div") {
                            elemHtml = `<${documentStructelement.structuringelement.label}
                              class="division"
                              data-element-num="${++countDiv}"
                              data-id="${documentStructelement.id}"><span class="legam-zw">${countDiv} </span> `
                          }
                          else {
                            elemHtml = `<${documentStructelement.structuringelement.label} data-id="${documentStructelement.id}">`
                          }

                          if (!(documentStructelement.structuringelement.label in openedElements)) {
                            openedElements[documentStructelement.structuringelement.label] = 0
                          }
                          if (openedElements[documentStructelement.structuringelement.label] > 0) {
                            addContent = `</${documentStructelement.structuringelement.label}>${elemHtml}`
                          }
                          else {
                            addContent = elemHtml
                            openedElements[documentStructelement.structuringelement.label]++
                          }
                        }
                      }
                    }
                  }
                  else {
                    if (documentStructelement.structuringelement.label == "zw") {
                      if ((this.editMode == true && this.editViewType == 'zw') ||
                          (this.editMode == false && this.viewType == 'diplomatic')
                      ){
                        if (countZw == 1){
                          let beforeContent = `<div
                            class="legam-line"
                            data-element-num="${countZw}"
                            data-id="${this.document.structElemenentsId['zw'][countZw-1]}"><span
                            class="legam-zw">${countZw}</span> `
                          shift += beforeContent.length
                          content = `${beforeContent}${content}</div>`
                        }

                        if (token.idx < documentStructelement.idx && (token.idx + token.length) > documentStructelement.idx){
                          let zwText = `</div><div
                            class="legam-line"
                            data-element-num="${++countZw}"
                            data-id="${this.document.structElemenentsId['zw'][countZw-1]}"><span
                            class="legam-zw inside">${countZw}</span> `
                          tokenText = `${tokenText.substring(0, documentStructelement.idx - token.idx)}${zwText}${tokenText.substring(documentStructelement.idx - token.idx)}`
                          addContent = ""
                          // addContent = `</div><div
                          //   class="legam-line"
                          //   data-element-num="${++countZw}"
                          //   data-id="${this.document.structElemenentsId['zw'][countZw-1]}"><span
                          //   class="legam-zw">${countZw}</span>`
                        }
                        else {
                          addContent = `</div><div
                            class="legam-line"
                            data-element-num="${++countZw}"
                            data-id="${this.document.structElemenentsId['zw'][countZw-1]}"><span
                            class="legam-zw">${countZw}</span> `
                        }
                      }
                      else if (this.editMode == false) {
                        if (token.idx < documentStructelement.idx && (token.idx + token.length) > documentStructelement.idx){
                          let zwText = `<span class="legam-zw inside">\\${++countZw}</span>`
                          tokenText = `${tokenText.substring(0, documentStructelement.idx - token.idx)}${zwText}${tokenText.substring(documentStructelement.idx - token.idx)}`
                          addContent = ""
                        }
                        else {
                          addContent += `<span class="legam-zw">\\${++countZw}</span>`
                        }
                      }
                    }
                    else if (documentStructelement.structuringelement.label == "par") {
                      if (this.editMode == true && this.editViewType == 'par') {
                        if (countPar == 1){
                          let beforeContent = `<div
                            class="legam-par"
                            data-element-num="${countPar}"
                            data-id="${this.document.structElemenentsId['par'][countPar-1]}"><span
                            class="legam-zw">${countPar}</span> `
                          shift += beforeContent.length
                          content = `${beforeContent}${content}</div>`
                        }
                        addContent = `</div><div
                          class="legam-par"
                          data-element-num="${++countPar}"
                          data-id="${this.document.structElemenentsId['par'][countPar-1]}"><span
                          class="legam-zw">${countPar}</span> `
                      }
                      else if (this.editMode == false) {
                        addContent += `<span class="legam-par"></span>`
                        if (this.viewType == 'critic' | this.viewType == 'interpretative') {
                          addContent += '<br>'
                        }
                      }
                    }
                    else {
                      addContent = `<${documentStructelement.structuringelement.label}/>`
                    }

                  }
                  content = `${content.substring(0, token.idx + shift)}${addContent}${content.substring(token.idx + shift)}`
                  shift += addContent.length
                }
              }

              let highlightClass = 'hl0'
              if (token.highlight == true){
                highlightClass = `hl1`
              }
              else if (token.lemmatized) {
                highlightClass = `hl2`
                this.tokenLemmas[token.id] = token.lemmas
              }

              let addBeforeShift = 0
              if (this.document.content.substring(token.idx, token.idx + 6) == "<punct"){
                addBeforeShift = 1
                let punct = this.document.content.substring(token.idx, token.idx + token.length)
                const regex = /<punct?( original="<?(?<original>.*)"){0,1}\/{0,1}>(?<modern>.){0,1}(<\/punct>){0,1}/i;
                let result = punct.match(regex)

                if (result){
                  if (this.editMode == true || (this.editMode == false && this.viewType == 'critic')){
                    tokenText = result.groups.modern ? result.groups.modern : ''
                    if (this.editMode == true && this.editViewType == 'div' && result.groups.original && result.groups.modern) {
                      tokenText = ' · ' + result.groups.modern
                    }
                    else if (this.editMode == false &&
                      this.viewType == 'critic' &&
                      result.groups.original &&
                      result.groups.original.length > 1 &&
                      result.groups.original[0] == '.' &&
                      result.groups.original.slice(-1) == '.'
                    ){
                      addBeforeShift = 0
                      tokenText = result.groups.original.replace(/\./gi, '·')
                    }
                    else if (result.groups.original) {
                      addBeforeShift = 0
                      tokenText = '·'
                    }
                  }
                  else if (this.viewType == 'interpretative') {
                    tokenText = result.groups.modern ? result.groups.modern : ''
                  }
                  else if (this.viewType == 'diplomatic') {
                    tokenText = ''
                    if (result.groups.original && result.groups.original.length > 1 && result.groups.original[0] == '.' && result.groups.original.slice(-1) == '.'){
                      addBeforeShift = 0
                      tokenText = result.groups.original.replace(/\./gi, '·')
                    }
                    else if (result.groups.original){
                      addBeforeShift = 0
                      tokenText = '·'
                    }
                  }
                }
              }
              let addAfterShift = 0
              if (["<punct>-", "<punct>'"].includes(this.document.content.substring(token.idx, token.idx + 8))){
                addAfterShift = 1
              }
              if (this.document.content.substring(token.idx, token.idx + 4) == "<num" && (
                  this.editMode == true ||
                  (this.editMode == false && this.viewType == 'critic') ||
                  (this.editMode == false && this.viewType == 'diplomatic')
              )){
                let num = this.document.content.substring(token.idx, token.idx + token.length)
                const regex = /<num?( original="<?(?<original>.*)"){0,1}\/{0,1}>(?<modern>.){0,1}(<\/num>){0,1}/i;
                let result = num.match(regex)
                if (result){
                  tokenText = result.groups.modern
                  if (result.groups.original){
                    tokenText = result.groups.original.replace(/\./gi, '·')
                  }
                }
              }

              // console.log(
              //   token.newIndex,
              //   token.newLength,
              //   // content.substring(token.newIndex -1 + shift, token.newIndex -1 + token.newLength + shift),
              //   tokenText,
              //   token.idx,
              //   token.length,
              //   // this.document.content_org.substring(token.idx, token.idx + token.length),
              //   addBeforeShift,
              //   addAfterShift,
              // )

              tokenText = `<span class="${highlightClass}" data-id="${token.id}">${tokenText}</span>`
              content = `${content.substring(0, token.idx + shift - addBeforeShift)}${tokenText}${afterTokenText}${content.substring(token.length + token.idx + shift + addAfterShift)}`
              shift += (tokenText.length - token.length - addBeforeShift - addAfterShift + afterTokenText.length)
            }

            // Close opened elements
            for (let element of Object.keys(openedElements)) {
              while (openedElements[element] > 0) {
                content += `</${element}>`
                openedElements[element]--
              }
            }
          }
        }
        this.computedContent = content;
      },
      letterNumeration: Utils.letterNumeration,
      mouseLeave() {
        this.showContextMenu = false
      },
      reloadData() {
        this.documentTokens = []
        this.$store.dispatch('loadDocument', {
          documentId: this.documentId,
          changes: this.contentChanges
        })
        this.$store.dispatch('loadTokensForDocument', this.documentId)
      },
      openContextMenu(event) {
        // if (this.editMode == true || this.editMode == false) {
        console.log(1233);
        let elem = null
        let className = 'division'

        if (this.editViewType == 'par'){
          className = 'legam-par'
        }
        else if (this.editViewType == 'zw') {
          className = 'legam-line'
        }

        if (event.target.classList.contains(className)){
          elem = event.target
        }
        else {
          elem = event.target.parentNode.closest(`.${className}`)
        }
        if (elem && (this.config.editable || event.target.dataset.id in this.tokenLemmas)) {
          this.CMleft = event.clientX
          this.CMtop = event.clientY
          this.showContextMenu = true
          this.elementNum = parseInt(elem.dataset.elementNum, 10)
          this.contextMenuLemmas = event.target.dataset.id in this.tokenLemmas ? this.tokenLemmas[event.target.dataset.id] : []
          if (this.editViewType == 'div'){
            this.canElementBeMerged = this.document.joinableDivs.includes(parseInt(this.elementNum, 10))
          }
          else {
            this.canElementBeMerged = (elem.dataset.id != "undefined")
          }
        }
        // }
      },

      // Merge elements
      mergeElements() {
        let elementNum = this.editViewType == 'div' ? this.elementNum : this.elementNum-1
        this.contentChanges.push({
          type: this.editViewType,
          action: 'delete',
          id: this.document.structElemenentsId[this.editViewType][elementNum]
        })
        this.reloadData()
      },

      // Split element
      splitElement() {
        this.$store.dispatch('getElementDetails', {
          documentId: this.documentId,
          elementNum: this.elementNum,
          elementType: this.editViewType
        }).then(data => {
          let addOffset = this.editViewType == 'zw' ? 1 : 0
          data.allowedIndices.legal_indices_shifted = data.allowedIndices.legal_indices.map(x => x - data.allowedIndices.offset - addOffset)
          this.splitElementData = data
          this.splitElementIndex = 1
          this.$bvModal.show('modal-split-element')
        })
      },
      splitElementSetIndex(chosenIndex) {
        // Find nearest index
        let index = 0
        for (index in this.splitElementData.allowedIndices.legal_indices_shifted){
          if (chosenIndex <= this.splitElementData.allowedIndices.legal_indices_shifted[index]) {
            break
          }
        }
        this.splitElementIndex = index
      },
      saveSplitElement() {
        let addOffset = this.editViewType == 'zw' ? 2 : 0
        this.contentChanges.push({
          type: this.editViewType,
          action: 'create',
          index: this.splitElementData.allowedIndices.legal_indices[this.splitElementIndex] + 1 - addOffset,
        })
        this.reloadData()
      },

      // Footnotes
      addFootnote() {
        this.$store.dispatch('getElementDetails', {
          documentId: this.documentId,
          elementNum: this.elementNum,
          elementType: this.editViewType
        }).then(data => {
          data.allowedIndices.legal_indices_shifted = data.allowedIndices.legal_indices.map(x => x - data.allowedIndices.offset)
          this.footnoteData = data
          this.footnoteText = ''
          this.footnoteIndex = 1
          this.$bvModal.show('modal-add-footnote')
        })
      },
      footnoteSetIndex(chosenIndex) {
        // Find nearest index
        let index = 0
        for (index in this.footnoteData.allowedIndices.legal_indices_shifted){
          if (chosenIndex <= this.footnoteData.allowedIndices.legal_indices_shifted[index]) {
            break
          }
        }
        this.footnoteIndex = index
      },
      saveFootnote() {
        this.contentChanges.push({
          type: this.footnoteType,
          action: 'create',
          content: this.footnoteText,
          index: this.footnoteData.allowedIndices.legal_indices[this.footnoteIndex],
        })
        this.reloadData()
      },
      editFootnote(footnote) {
        this.footnoteId = footnote.id
        this.footnoteText = footnote.content
        this.$bvModal.show('modal-edit-footnote')
      },
      saveEditFootnote() {
        this.contentChanges.push({
          type: 'footnote',
          action: 'update-content',
          id: this.footnoteId,
          content: this.footnoteText
        })
        this.reloadData()
      },
      deleteFootnote(footnote) {
        this.$bvModal.msgBoxConfirm('Are you sure?').then(value => {
          if (value){
            this.contentChanges.push({
              type: footnote.structuringelement.label,
              action: 'delete',
              id: footnote.id
            })
            this.reloadData()
          }
        })
      },

      unlockEdit() {
        // this.editMode = true
        this.$store.dispatch('lockDocument', {
          documentId: this.documentId,
          status: 'lock'
        }).then(data => {
          if (data.status == 'ok') {
            this.editMode = true
            this.computeContent()
          }
          else if (data.status == 'false'){
            this.$store.dispatch('addNotification', {
              type: 'warning',
              text: `Document is locked by ${data.username}`
            })
          }
        })
      },

      filterDivision() {
        this.divisionFilter = this.elementNum
        this.indexKeyTokenTable++
        this.$store.dispatch('addNotification', {
          type: 'success',
          text: `Tokens filtered by division ${this.divisionFilter}`
        })
        this.showContextMenu = false
      },
      highlightToken(data){
        this.documentTokens = this.tokens.map(token => {
          token.highlight = false
          if (token.id == data.id){
            token.highlight = true
          }
          return token
        })
        window.scrollTo(20, top);
      },
      selectEdition(edition){
        this.document.editionId = null
        this.document.edition = null
        if (edition) {
          this.document.editionId= edition.id
          this.document.edition = edition
        }
      },
      selectCorpusEdition(edition){
        this.document.corpus.editionId = null
        this.document.corpus.edition = null
        if (edition) {
          this.document.corpus.editionId= edition.id
          this.document.corpus.edition = edition
        }
      },
      selectManuscript(manuscript){
        this.document.manuscriptId = null
        this.document.manuscript = null
        if (manuscript){
          this.document.manuscriptId= manuscript.id
          this.document.manuscript = manuscript
        }
      },
      selectText(text){
        this.document.textId = null
        this.document.text = null
        if (text) {
          this.document.textId= text.id
          this.document.text = text
        }
      },
      selectCorpus(corpus){
        this.document.corpusId = null
        this.document.corpus = null
        if (corpus){
          this.document.corpusId = corpus.id
          this.document.corpus = corpus
        }
      },
      cancelEdit(){
        this.$store.dispatch('lockDocument', {
          documentId: this.documentId,
          status: 'unlock'
        }).then(data => {
          if (data.status == 'ok') {
            this.editMode = false
            this.contentChanges = []
            this.reloadData()
          }
        })
      },
      saveEdit(){
        this.editMode = false
        this.$store.dispatch('saveDocument', {
          document: this.document,
          changes: this.contentChanges
        }).then(() => {
          this.contentChanges = []
          this.reloadData()
          this.$store.dispatch('addNotification', {
            type: 'success',
            text: `Changes saved`
          })
        })
      },
      deleteItem(){
        this.$bvModal.msgBoxConfirm('Are you sure?').then(value => {
          if (value){
            this.$store.dispatch('deleteDocument', this.document).then(() => {
              router.push('/documents')
            })
          }
        })
      },
      scriptoriumString: Utils.scriptoriumString,
    },
    components: {
      PageTitle,
      EditionSelect,
      ManuscriptSelect,
      CorpusSelect,
      TokenTable,
      TextSelect
    },
    watch: {
      'documentId'(){
        this.loading = true
        this.$store.dispatch('loadDocument', this.documentId)
      },
      'document'(){
        this.loading = false

        if (this.document && this.documentTokens) {
          this.computeContent()
        }
        console.log("DOC", this.document)
      },
      'viewType'(){
        this.computeContent()
      },
      'editViewType'(){
        this.computeContent()
      },
      'tokens'(){
        this.indexKeyTokenTable++
        this.documentTokens = this.tokens

        if (this.document && this.documentTokens) {
          this.computeContent()
        }
      },
    },
  }
</script>
